import React, { useState, useRef, useEffect, useCallback } from 'react';
import ReactSelect from 'react-select';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import ProgressSteps from '../NewListing/ProgressSteps';
import { FaHome, FaWifi, FaTv, FaWater, FaUtensils, FaCar, FaArrowsAltV, FaSnowflake, FaSmokingBan, FaBellSlash, FaBath, FaEye, FaArrowLeft, FaMapMarkerAlt, FaUser, FaBed, FaParking, FaRuler, FaHeart, FaShare, FaWhatsapp, FaTrash, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
// Toast estilizado
const Toast = styled.div`
  position: fixed;
  bottom: 80px;
  right: 32px;
  background: ${props => props.type === 'success' ? '#22c55e' : '#ef4444'};
  color: white;
  padding: 18px 32px;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.13);
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 9999;
  min-width: 280px;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @media (max-width: 768px) {
    bottom: 100px;
    right: 16px;
    left: 16px;
    min-width: auto;
  }
`;

// Layout principais da página (mesmos do NewListing)
const PageContainer = styled.div`
  min-height: calc(100vh - 80px);
  padding: 40px 20px;
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 24px;

  @media (max-width: 1400px) {
    grid-template-columns: 280px 1fr;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const Sidebar = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: fit-content;
  position: sticky;
  top: 24px;
`;

const MainContent = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  background: #34574A;
  padding: 32px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.h1`
  font-size: 1.75rem;
  margin: 0;
  color: white;
`;

const Subtitle = styled.p`
  margin: 8px 0 0;
  opacity: 0.8;
  font-size: 1rem;
`;

// Preview simples (seção fixa abaixo do formulário) usado pelo EditListing
const Preview = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: fit-content;
  overflow: hidden;
  margin-top: 24px;
`;

const PreviewHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid #edf2f7;
  
  h2 {
    font-size: 1rem;
    color: #2d3748;
    margin: 0;
  }
`;

const PreviewContent = styled.div`
  padding: 24px;
`;

const PreviewImage = styled.div`
  width: 100%;
  padding-top: 66.67%;
  background: ${props => props.$image ? `url(${props.$image}) center/cover no-repeat` : '#edf2f7'};
  border-radius: 8px;
  margin-bottom: 24px;
`;

const StepContent = styled.div`
  padding: 32px;
`;

// Preview Modal (similar ao NewListing)
const PreviewModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;
const PreviewModalBox = styled.div`
  width: 90vw;
  max-height: 90vh;
  overflow: auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.25);
`;
const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #edf2f7;
  h3 { margin: 0; color: #34574A; }
`;
const CloseModal = styled.button`
  border: none;
  background: #34574A;
  color: #fff;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
`;
const ModalBody = styled.div`
  padding: 16px 20px 24px;
`;
const ContentContainer = styled.div`
  width: 80%;
  margin: 0 auto;
`;
const ModalGrid = styled.div`
  display: grid;
  grid-template-columns: 5fr 1fr;
  gap: 24px;
  @media (max-width: 1100px) { grid-template-columns: 2fr 1fr; }
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;
// Barra de ações e colunas laterais (como NewListing)
const ActionBar = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin: 10px 0 18px 0;
`;
const LeftGroup = styled.div``;
const RightGroup = styled.div`
  display: flex;
  gap: 8px;
`;
const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
`;
const BackLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #111827;
  padding: 6px 10px;
  border-radius: 10px;
`;
const Badge = styled.span`
  background: #111827;
  color: #fff;
  border-radius: 999px;
  padding: 6px 10px;
  font-weight: 800;
  font-size: 12px;
`;
const TitleStatus = styled.h2`
  margin: 6px 0;
  font-size: 22px;
  font-weight: 800;
  color: #111827;
`;
const LocationText = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #6b7280;
  font-weight: 600;
  font-size: 14px;
`;
const SideInfo = styled.div``;
const FactsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 16px;
`;
const FactItem = styled.div`
  display: grid;
  grid-template-columns: 28px 1fr;
  gap: 10px;
  align-items: center;
  .label { font-size: 12px; color: #6b7280; font-weight: 700; }
  .value { font-size: 14px; color: #111827; font-weight: 800; }
`;
const GhostButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #111827;
  padding: 6px 10px;
  border-radius: 10px;
`;
const BookingBox = styled.div``;
const SideAction = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #111827;
  padding: 10px 12px;
  border-radius: 10px;
  font-weight: 700;
`;
const SideButton = styled(SideAction)``;
const HostCard = styled.div`
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  padding: 12px;
  margin-top: 12px;
  text-align: center;
  .avatar { display: flex; justify-content: center; margin-bottom: 8px; }
  .name { font-weight: 800; color: #111827; }
  .role { color: #6b7280; font-size: 13px; margin-bottom: 6px; }
  .line { color: #374151; font-size: 13px; }
  .rating { margin-top: 6px; color: #6b7280; font-size: 13px; }
`;
// Replicados do NewListing (Hero e EyeButton)
const EyeButton = styled.button`
  background: #fff;
  border: 1px solid #e5e7eb;
  color: #111827;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0,0,0,0.06);
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s ease, border-color 0.2s ease;
  &:hover { background: #f9fafb; border-color: #d1d5db; }
`;

const HeroGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 8px;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;
const HeroMain = styled.div`
  width: 100%;
  padding-top: 56.25%;
  border-radius: 0px;
  background: ${p => p.$image ? `url(${p.$image}) center/cover no-repeat` : '#f1f5f9'};
`;
const RightMosaic = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  gap: 8px;
`;
const HeroThumb = styled.div`
  width: 100%;
  padding-top: 56.25%;
  border-radius: 0px;
  background: ${p => p.$image ? `url(${p.$image}) center/cover no-repeat` : '#f8fafc'};
  position: relative;
`;
const ViewAllButton = styled.button`
  position: absolute;
  right: 8px;
  bottom: 8px;
  background: rgba(17,24,39,0.7);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.2);
  padding: 8px 10px;
  border-radius: 8px;
`;
// Lightbox (replicado do NewListing)
const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11000;
`;
const LightboxImage = styled.div`
  width: min(1200px, 95vw);
  height: min(80vh, 900px);
  background: ${p => p.$image ? `url(${p.$image}) center/contain no-repeat` : 'transparent'};
  border-radius: 0px;
`;
const LightboxNav = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${p => p.$left ? 'left: 24px;' : 'right: 24px;'}
  background: rgba(255,255,255,0.15);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.25);
  padding: 10px 14px;
  border-radius: 8px;
`;
const LightboxClose = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background: rgba(255,255,255,0.15);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.25);
  padding: 10px 14px;
  border-radius: 8px;
  z-index: 2;
  cursor: pointer;
`;
const SectionCard = styled.div`
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 20px;
  margin: 22px 0 14px 0;
`;
const PillTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 800;
  color: #2d3748;
  margin: 0 0 12px 0;
`;
const AmenitiesList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
`;
const AmenityRow = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  .icon { color: #64748b; }
`;

// Removidos duplicados de PreviewHeader/PreviewContent/PreviewImage (já definidos abaixo)

const PreviewInfo = styled.div`
  h3 {
    font-size: 1.25rem;
    color: #2d3748;
    margin: 0 0 8px 0;
  }

  .price {
    font-size: 1.5rem;
    color: #34574A;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .details {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 24px;

    .item {
      .label {
        font-size: 0.75rem;
        color: #718096;
        margin-bottom: 4px;
      }
      .value {
        font-size: 0.875rem;
        color: #2d3748;
        font-weight: 500;
      }
    }
  }

  .description {
    font-size: 0.875rem;
    color: #4a5568;
    line-height: 1.5;
  }
`;

const NavigationButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 32px;
  border-top: 1px solid #edf2f7;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &.secondary {
    background: white;
    border: 2px solid #e2e8f0;
    color: #4a5568;

    &:hover {
      background: #f7fafc;
      border-color: #cbd5e0;
    }
  }

  &.primary {
    background: #34574A;
    border: none;
    color: white;

    &:hover {
      background: #2a4539;
    }
  }
`;

const FormSection = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h3`
  font-size: 1.125rem;
  color: #2d3748;
  margin: 0 0 24px 0;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  &.three-columns {
    grid-template-columns: repeat(3, 1fr);

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px; // Added consistent spacing between inputs

  &.full-width {
    grid-column: 1 / -1;
  }
`;

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
`;

const Input = styled.input`
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    border-color: #34574A;
    outline: none;
    box-shadow: 0 0 0 3px rgba(52, 87, 74, 0.1);
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

const MonetaryInput = styled(Input)`
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;
`;

const NumericInput = styled(Input)`
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;
`;

const Select = styled.select`
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
  color: #2d3748;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 8px;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #4a5568;
`;

const RadioInput = styled.input`
  cursor: pointer;
  width: 18px;
  height: 18px;
  accent-color: #34574A;
`;

const TextArea = styled.textarea`
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  resize: vertical;
  min-height: 120px;
  transition: all 0.3s ease;

  &:focus {
    border-color: #34574A;
    outline: none;
    box-shadow: 0 0 0 3px rgba(52, 87, 74, 0.1);
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

const PhotosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
`;

const PhotoUploadBox = styled.div`
  border: 2px dashed #e2e8f0;
  border-radius: 8px;
  aspect-ratio: 1;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${props => props.$preview ? `url(${props.$preview}) center/cover no-repeat` : 'white'};

  &:hover {
    border-color: #34574A;
    background-color: ${props => props.$preview ? 'initial' : '#f7fafc'};
  }

  input {
    display: none;
  }

  .icon {
    font-size: 1.5rem;
    color: #a0aec0;
    margin-bottom: 8px;
  }

  .text {
    font-size: 0.75rem;
    color: #4a5568;
    text-align: center;
  }

  ${props => props.$preview && `
    .icon, .text {
      display: none;
    }
  `}

  .remove {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: ${props => props.$preview ? 1 : 0};
    transition: opacity 0.3s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }
  }

  &.main-photo {
    grid-column: span 2;
    grid-row: span 2;
  }
`;

const AmenitiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
`;

const ExtrasList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ExtraItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  transition: all 0.3s ease;

  &:hover {
    border-color: #34574A;
    background: #f7fafc;
  }

  .text {
    font-size: 0.875rem;
    color: #4a5568;
    flex: 1;
  }
`;

const RemoveButton = styled.button`
  background: transparent;
  border: 1px solid #e5e7eb;
  color: #b91c1c;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-left: 12px;

  &:hover {
    background: #fef2f2;
    border-color: #fecdd3;
    color: #991b1b;
  }
`;

const AddExtrasRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const AddButton = styled.button`
  padding: 12px 24px;
  background: #34574A;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: #2a4539;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Amenity = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #34574A;
    background: #f7fafc;
  }

  input {
    width: 16px;
    height: 16px;
  }

  .icon {
    width: 24px;
    height: 24px;
    color: #4a5568;
  }

  .text {
    font-size: 0.875rem;
    color: #4a5568;
  }

  ${props => props.$checked && `
    border-color: #34574A;
    background: #f0fff4;
  `}
`;

// ATENÇÃO: Defina sua chave da API do Google Places aqui ou em um .env seguro
const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

const EditProperty = () => {
  const { id } = useParams(); // Pega o ID do Imóvel da URL
  const [loading, setLoading] = useState(true); // Estado para controlar o carregamento
  const [toast, setToast] = React.useState({ open: false, message: '', type: 'success' });
  const showToast = (message, type = 'success', duration = 4000) => {
    setToast({ open: true, message, type });
    setTimeout(() => setToast({ open: false, message: '', type }), duration);
  };

  // Handler para salvar (etapa final). Como os PATCHs já são enviados ao digitar,
  // este botão funciona como confirmação visual e ponto único de validação.
  const handleSaveAll = async () => {
    // Função auxiliar para identificar campos faltantes na Etapa 5
    const missingStep5Fields = () => {
      const missing = [];
      if (formData.exibirPreco && !String(formData.valorIMOVEL || '').trim()) missing.push('Preço');
      
      // Detecta Férias/Diária para exigir permanências e Horários
      const selTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
      let slug = selTipo?.slugTIPOIMOVEL || '';
      if (!slug) {
        const lbl = String(formData.labelvalorIMOVEL || '').toLowerCase();
        if (['Diária','diaria','semana','mês','mes'].includes(lbl)) slug = 'ferias';
        else if (['ano','mês','mes'].includes(lbl)) slug = 'arrendar';
        else if (['venda','comprar','buy','sell'].includes(lbl)) slug = 'comprar';
      }
      const isFerias = /^(ferias|vacation)$/i.test(slug);
      
      // Label não é obrigatório para férias
      if (!isFerias && !String(formData.labelvalorIMOVEL || '').trim()) missing.push('Período');
      
      if (!formData.politicacancelamentoIMOVEL) missing.push('Política de Cancelamento');
      
      if (isFerias) {
        if (!formData.permanenciaminimaIMOVEL) missing.push('Permanência Mínima');
        if (!formData.permanenciamaximaIMOVEL) missing.push('Permanência Máxima');
        if (!formData.checkinIMOVEL) missing.push('Horário de Check-in');
        if (!formData.checkoutIMOVEL) missing.push('Horário de Check-out');
        // Validar campos de limpeza e taxa de turismo
        if (formData.limpezaCobrada && !String(formData.valorLimpeza || '').trim()) missing.push('Valor da Limpeza');
        if (formData.taxaTurismoCobrada) {
          if (!String(formData.valorTaxaTurismoAdulto || '').trim()) missing.push('Valor da Taxa de Turismo (Adulto)');
          if (!String(formData.valorTaxaTurismoCrianca || '').trim()) missing.push('Valor da Taxa de Turismo (Criança)');
          if (!String(formData.idadeMaximaCrianca || '').trim()) missing.push('Idade Máxima para Criança');
        }
      }
      return missing;
    };

    try {
      // Valida apenas a etapa atual (Etapa 5: Regras e Preços)
      if (!validateStep(5)) {
        const missing = missingStep5Fields();
        console.warn('Campos faltantes (Etapa 5):', missing);
        const msg = missing.length
          ? `Faltando: ${missing.join(', ')}`
          : 'Preencha os campos obrigatórios de Regras e Preços antes de salvar.';
        showToast(msg, 'error');
        return;
      }
      // Envia PATCH consolidado com campos da Etapa 5 e campos adicionais mapeados
      const toInt = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : undefined;
      };
      const toInt01 = (v) => v === 1 || v === '1' || v === true || String(v).toLowerCase() === 'true' ? 1 : 0;

      const payload = (() => {
        const base = {};
        
        // Helper para adicionar campo apenas se tiver valor definido (não undefined/null)
        const addField = (key, value) => {
          if (typeof value !== 'undefined' && value !== null) {
            base[key] = value;
          }
        };

        // Regras e Preços
        addField('valorIMOVEL', formData.valorIMOVEL);
        addField('labelvalorIMOVEL', formData.labelvalorIMOVEL);
        addField('politicacancelamentoIMOVEL', formData.politicacancelamentoIMOVEL);
        addField('exibirPreco', typeof formData.exibirPreco !== 'undefined' ? (formData.exibirPreco ? 1 : 0) : undefined);
        // Descrição e Regras
        addField('descricaoIMOVEL', formData.descricaoIMOVEL);
        addField('regrasadicionaisIMOVEL', formData.regrasadicionaisIMOVEL);
        
        // Detecta Férias/Diária
        const selTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
        let slug = selTipo?.slugTIPOIMOVEL || '';
        if (!slug) {
          const lbl = String(formData.labelvalorIMOVEL || '').toLowerCase();
          if (['Diária','diaria','semana','mês','mes'].includes(lbl)) slug = 'ferias';
          else if (['ano','mês','mes'].includes(lbl)) slug = 'arrendar';
          else if (['venda','comprar','buy','sell'].includes(lbl)) slug = 'comprar';
        }
        const isFerias = /^(ferias|vacation)$/i.test(slug);
        if (isFerias) {
          addField('permanenciaminimaIMOVEL', formData.permanenciaminimaIMOVEL);
          addField('permanenciamaximaIMOVEL', formData.permanenciamaximaIMOVEL);
          addField('checkinIMOVEL', formData.checkinIMOVEL);
          addField('checkoutIMOVEL', formData.checkoutIMOVEL);
          // Holiday rental specific fields - conversão explícita de boolean
          const limpezaCobradaBool = formData.limpezaCobrada === true || formData.limpezaCobrada === 1 || formData.limpezaCobrada === '1';
          addField('limpezaCobrada', limpezaCobradaBool ? 1 : 0);
          if (limpezaCobradaBool) {
            addField('valorLimpeza', formData.valorLimpeza);
          }
          const taxaTurismoCobradaBool = formData.taxaTurismoCobrada === true || formData.taxaTurismoCobrada === 1 || formData.taxaTurismoCobrada === '1';
          addField('taxaTurismoCobrada', taxaTurismoCobradaBool ? 1 : 0);
          if (taxaTurismoCobradaBool) {
            addField('valorTaxaTurismoAdulto', formData.valorTaxaTurismoAdulto);
            addField('valorTaxaTurismoCrianca', formData.valorTaxaTurismoCrianca);
            addField('idadeMaximaCrianca', formData.idadeMaximaCrianca);
          }
        }
        // Campos adicionais, se existirem nesta etapa
        if (typeof formData.instantBooking !== 'undefined') addField('instantBooking', formData.instantBooking);
        if (typeof formData.financiamentoIMOVEL !== 'undefined') addField('financiamentoIMOVEL', formData.financiamentoIMOVEL);

        // Localização (enderecos)
        addField('enderecoIMOVEL', formData.enderecoIMOVEL);
        addField('numeroIMOVEL', formData.numeroIMOVEL);
        addField('zipcodeIMOVEL', formData.zipcodeIMOVEL);
        addField('cityIMOVEL', formData.cityIMOVEL);
        addField('stateIMOVEL', formData.stateIMOVEL);
        addField('latitudeIMOVEL', formData.latitudeIMOVEL);
        addField('longitudeIMOVEL', formData.longitudeIMOVEL);
        // País pode vir como código string ("BR", "PT"). Salva ambos para compat.
        if (typeof formData.countryIMOVEL !== 'undefined' && formData.countryIMOVEL !== '') addField('countryIMOVEL', String(formData.countryIMOVEL));
        if (typeof formData.paisIMOVEL !== 'undefined' && formData.paisIMOVEL !== '') {
          // mantém como string para Não perder códigos tipo "BR"
          addField('paisIMOVEL', String(formData.paisIMOVEL));
          if (!base.countryIMOVEL) addField('countryIMOVEL', String(formData.paisIMOVEL));
        }

        // Imobiliária e Agente (quando disponíveis)
        if (typeof formData.imobiliariaIMOVEL !== 'undefined' && formData.imobiliariaIMOVEL !== '') addField('imobiliariaIMOVEL', formData.imobiliariaIMOVEL);
        if (typeof formData.agenteIMOVEL !== 'undefined' && formData.agenteIMOVEL !== '') addField('agenteIMOVEL', formData.agenteIMOVEL);
        // ID do Imóvel (sempre envia se tiver valor)
        if (typeof formData.codigoIMOVEL !== 'undefined' && formData.codigoIMOVEL !== '') addField('codigoIMOVEL', formData.codigoIMOVEL);

        // Características (integers)
        if (typeof formData.tipometragemIMOVEL !== 'undefined' && formData.tipometragemIMOVEL !== '') {
          const mapTipometragem = (v) => {
            if (v === 'm²') return 1;
            if (v === 'ft²') return 2;
            const n = Number(v);
            return Number.isFinite(n) ? n : undefined;
          };
          const t = mapTipometragem(formData.tipometragemIMOVEL);
          if (typeof t !== 'undefined') addField('tipometragemIMOVEL', t);
        }
        if (typeof formData.andaresIMOVEL !== 'undefined' && formData.andaresIMOVEL !== '') addField('andaresIMOVEL', toInt(formData.andaresIMOVEL));
        if (typeof formData.anoconstrucaoIMOVEL !== 'undefined' && formData.anoconstrucaoIMOVEL !== '') addField('anoconstrucaoIMOVEL', toInt(formData.anoconstrucaoIMOVEL));
        if (typeof formData.situacaoIMOVEL !== 'undefined' && formData.situacaoIMOVEL !== '') {
          const mapSit = (v) => {
            if (v === 'novo') return 1;
            if (v === 'usado') return 2;
            if (v === 'em_construcao') return 3;
            const n = Number(v);
            return Number.isFinite(n) ? n : undefined;
          };
          const s = mapSit(formData.situacaoIMOVEL);
          if (typeof s !== 'undefined') addField('situacaoIMOVEL', s);
        }
        if (typeof formData.posicaosolarIMOVEL !== 'undefined' && formData.posicaosolarIMOVEL !== '') {
          const mapPos = (v) => {
            if (v === 'norte') return 1;
            if (v === 'sul') return 2;
            if (v === 'leste') return 3;
            if (v === 'oeste') return 4;
            const n = Number(v);
            return Number.isFinite(n) ? n : undefined;
          };
          const p = mapPos(formData.posicaosolarIMOVEL);
          if (typeof p !== 'undefined') addField('posicaosolarIMOVEL', p);
        }
        if (typeof formData.vagasgaragemIMOVEL !== 'undefined' && formData.vagasgaragemIMOVEL !== '') addField('vagasgaragemIMOVEL', toInt(formData.vagasgaragemIMOVEL));
        if (typeof formData.casadebanhoIMOVEL !== 'undefined' && formData.casadebanhoIMOVEL !== '') {
          console.log('🚿 DEBUG: casadebanhoIMOVEL no formData:', formData.casadebanhoIMOVEL);
          console.log('🚿 DEBUG: valor convertido com toInt:', toInt(formData.casadebanhoIMOVEL));
          addField('casadebanhoIMOVEL', toInt(formData.casadebanhoIMOVEL));
        }
        if (typeof formData.qtdpessoasIMOVEL !== 'undefined' && formData.qtdpessoasIMOVEL !== '') addField('qtdpessoasIMOVEL', toInt(formData.qtdpessoasIMOVEL));
        if (typeof formData.solteirocamasIMOVEL !== 'undefined' && formData.solteirocamasIMOVEL !== '') addField('solteirocamasIMOVEL', toInt(formData.solteirocamasIMOVEL));
        if (typeof formData.casalcamasIMOVEL !== 'undefined' && formData.casalcamasIMOVEL !== '') addField('casalcamasIMOVEL', toInt(formData.casalcamasIMOVEL));
        if (typeof formData.quartosIMOVEL !== 'undefined' && formData.quartosIMOVEL !== '') addField('quartosIMOVEL', toInt(formData.quartosIMOVEL));
        if (typeof formData.metragemIMOVEL !== 'undefined' && formData.metragemIMOVEL !== '') addField('metragemIMOVEL', toInt(formData.metragemIMOVEL));

        // Sinalizadores/amenities (integers 0/1) - sempre envia mesmo se 0 para preservar estado
        const flags = [
          'lavanderiaIMOVEL','wifiIMOVEL','closetIMOVEL','arcondicionadoIMOVEL','fumarIMOVEL','salaodejogosIMOVEL','portariaIMOVEL','playgroundIMOVEL','proximoaometroIMOVEL','elevadorIMOVEL','poraoIMOVEL','quadraesportivaIMOVEL','festaIMOVEL','academiaIMOVEL','saunaIMOVEL','petsIMOVEL','coberturaIMOVEL','criancasIMOVEL','quadrabasqueteIMOVEL','sotaoIMOVEL','porteiroIMOVEL','jardimdefrenteIMOVEL','vistadolagoIMOVEL','vistadomarIMOVEL','espacoprivadoIMOVEL','adegaIMOVEL','sprinklersIMOVEL'
        ];
        // Acrescenta novas flags explícitas
        ['tvIMOVEL','aquecimentoIMOVEL','cozinhaIMOVEL','maquinadelavarIMOVEL','estacionamentoIMOVEL','piscinaIMOVEL','varandaIMOVEL','churrasqueiraIMOVEL','seguranca24hIMOVEL','mobiliadoIMOVEL']
          .forEach(k => { if (!flags.includes(k)) flags.push(k); });
        flags.forEach(k => {
          if (typeof formData[k] !== 'undefined') addField(k, toInt01(formData[k]));
        });

        // Piso/andar
        if (typeof formData.floorIMOVEL !== 'undefined' && formData.floorIMOVEL !== '') addField('floorIMOVEL', toInt(formData.floorIMOVEL));

        // Comodidades livres (array)
        if (Array.isArray(formData.comodidadesIMOVEL)) addField('comodidadesIMOVEL', formData.comodidadesIMOVEL);
        return base;
      })();

      console.log('🚿 DEBUG: Payload completo enviado ao backend:', payload);
      console.log('💰 DEBUG: exibirPreco no formData:', formData.exibirPreco, 'no payload:', payload.exibirPreco);
      console.log('🚿 DEBUG: casadebanhoIMOVEL no payload:', payload.casadebanhoIMOVEL);
      console.log('🧹 DEBUG: limpezaCobrada no formData:', formData.limpezaCobrada);
      console.log('🧹 DEBUG: valorLimpeza no formData:', formData.valorLimpeza);
      console.log('🧹 DEBUG: limpezaCobrada no payload:', payload.limpezaCobrada);
      console.log('🧹 DEBUG: valorLimpeza no payload:', payload.valorLimpeza);
      console.log('🏖️ DEBUG: taxaTurismoCobrada no formData:', formData.taxaTurismoCobrada);
      console.log('🏖️ DEBUG: valorTaxaTurismoAdulto no formData:', formData.valorTaxaTurismoAdulto);
      console.log('🏖️ DEBUG: valorTaxaTurismoCrianca no formData:', formData.valorTaxaTurismoCrianca);
      console.log('🏖️ DEBUG: idadeMaximaCrianca no formData:', formData.idadeMaximaCrianca);
      console.log('🏖️ DEBUG: taxaTurismoCobrada no payload:', payload.taxaTurismoCobrada);
      console.log('🏖️ DEBUG: valorTaxaTurismoAdulto no payload:', payload.valorTaxaTurismoAdulto);
      console.log('🏖️ DEBUG: valorTaxaTurismoCrianca no payload:', payload.valorTaxaTurismoCrianca);
      console.log('🏖️ DEBUG: idadeMaximaCrianca no payload:', payload.idadeMaximaCrianca);
      console.log('🆔 DEBUG: ID do imóvel no formData:', formData.codigoIMOVEL);
      console.log('🆔 DEBUG: ID do imóvel no payload:', payload.codigoIMOVEL);
      console.log('📦 DEBUG: Payload completo enviado:', payload);

      try {
        const token = localStorage.getItem('auth_token');
        const resp = await fetch(`${import.meta.env.VITE_URL_API}/imoveis/${id}`, {
          method: 'PATCH',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        const responseData = await resp.json();
        console.log('✅ DEBUG: Resposta da atualização:', responseData);
        if (!resp.ok) {
          const errText = await resp.text();
          console.error('Erro ao salvar (PATCH consolidado):', errText);
          showToast('Erro ao salvar no servidor.', 'error');
          return;
        }
      } catch (netErr) {
        console.error('Falha de rede no salvar (PATCH consolidado):', netErr);
        showToast('Falha de rede ao salvar.', 'error');
        return;
      }

      saveFormDataToLocalStorage();
      showToast('Alterações salvas com sucesso!', 'success');
      // Redireciona para a lista de Anúncios após salvar
      setTimeout(() => navigate('/dashboard/listings'), 500);
    } catch (e) {
      showToast('Não foi possível salvar as alterações.', 'error');
    }
  };
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]); // Controla etapas concluídas
  
  // Estados de Preview/Modal e Lightbox
  const [showPreview, setShowPreview] = useState(false);
  const [amenitiesExpanded, setAmenitiesExpanded] = useState(false);
  const [extrasExpanded, setExtrasExpanded] = useState(false);
  const [descriptionExpanded, setDescriptionExpanded] = useState(false);
  const [showLightbox, setShowLightbox] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const dragIndexRef = React.useRef(null);

  // Usuário atual (para exibir informações no HostCard do preview)
  const currentUser = (() => {
    try { return JSON.parse(localStorage.getItem('current_user') || 'null'); } catch { return null; }
  })();
  // Papel do usuário (para controlar exibição de campos corporativos)
  const role = (() => {
    try {
      const upper = (s) => (s || '').toString().trim().toUpperCase();
      const tokenize = (s) => upper(s).split(/[^A-Z]+/).filter(Boolean);
      const official = new Set(['ADMIN','PROFISSIONAL','EMPREENDIMENTO','PARTICULAR','USUARIO']);

      // 1) JWT (auth_token) tem prioridade
      const authToken = localStorage.getItem('auth_token');
      if (authToken && authToken.split('.').length === 3) {
        try {
          const b64url = authToken.split('.')[1];
          const b64 = b64url.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(b64url.length / 4) * 4, '=');
          const payload = JSON.parse(atob(b64));
          const raw = payload.role || payload.perfil || payload.tipo || payload.nivel || payload.papel || '';
          const tok = tokenize(raw).find(t => official.has(t));
          if (tok) return tok;
        } catch {
          // Ignore JWT parsing errors
        }
      }

      // 2) Fallback: auth_role
      const authRole = localStorage.getItem('auth_role');
      if (authRole) {
        const tok = tokenize(authRole).find(t => official.has(t));
        if (tok) return tok;
      }

      // 3) Fallback: current_user
      const r = currentUser && (currentUser.role || currentUser.perfil || currentUser.tipo || currentUser.nivel || currentUser.papel);
      const tok = tokenize(r).find(t => official.has(t));
      return tok || 'PARTICULAR';
    } catch {
      return 'PARTICULAR';
    }
  })();

  

  // Navegação direta entre etapas (utilizado no ProgressSteps)
  const goToStep = (step) => {
    setCurrentStep(step);
    setCompletedSteps(prev => prev.filter(s => s <= step));
  };
  const [formData, setFormData] = useState(() => {
    // Permite iniciar com dados vindos de props (Edição) ou vazio (novo)
    if (typeof window !== 'undefined' && window.history.state && window.history.state.editImovel) {
      return { ...window.history.state.editImovel };
    }
    return {
      tituloIMOVEL: '',
      slugIMOVEL: '',
      tipoIMOVEL: '',
      categoriaIMOVEL: '',
      planoIMOVEL: '',
      descricaoIMOVEL: '',
      regrasadicionaisIMOVEL: '',
      valorIMOVEL: '',
      imobiliariaIMOVEL: '',
      agenteIMOVEL: '',
      clienteIMOVEL: '',
      codigoIMOVEL: '',
      comodidadesIMOVEL: [],
      fotos: [],
      enderecoIMOVEL: '',
      numeroIMOVEL: '',
      zipcodeIMOVEL: '',
      cityIMOVEL: '',
      stateIMOVEL: '',
      paisIMOVEL: '',
      latitudeIMOVEL: '',
      longitudeIMOVEL: '',
      permanenciaminimaIMOVEL: '',
      permanenciamaximaIMOVEL: '',
      checkinIMOVEL: '',
      checkoutIMOVEL: '',
      ativoIMOVEL: '',
      instantBooking: false,
      politicacancelamentoIMOVEL: '',
      // Holiday rental specific fields
      limpezaCobrada: false,
      valorLimpeza: '',
      taxaTurismoCobrada: false,
      valorTaxaTurismoAdulto: '',
      valorTaxaTurismoCrianca: '',
      idadeMaximaCrianca: '',
      exibirPreco: true
    };
  });
  const [tiposImovel, setTiposImovel] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [planosCheckout, setPlanosCheckout] = useState([]);
  const [anunciosCount, setAnunciosCount] = useState({}); // Cache de contagem por pacote
  
  // Função para buscar contagem real de anúncios por pacote
  const fetchAnunciosCount = useCallback(async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const res = await fetch(`${import.meta.env.VITE_URL_API}/imoveis/me`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': 'application/json'
        }
      });
      if (res.ok) {
        const data = await res.json();
        const lista = data?.imoveis || [];
        const contagem = {};
        lista.forEach(anuncio => {
          if (anuncio.pacoteIMOVEL) {
            const pacoteKey = String(anuncio.pacoteIMOVEL);
            contagem[pacoteKey] = (contagem[pacoteKey] || 0) + 1;
          }
        });
        setAnunciosCount(contagem);
        return contagem;
      }
    } catch (error) {
      console.error('Erro ao buscar contagem de anúncios:', error);
    }
    return {};
  }, []);
  
  // Sincroniza planoIMOVEL a partir do pacoteIMOVEL (após states serem criados)
  useEffect(() => {
    try {
      if (!formData || !Array.isArray(planosCheckout)) return;
      const selected = planosCheckout.find(pkg => String(pkg?.codigoCHECKOUT) === String(formData?.pacoteIMOVEL));
      const selectedPlan = selected?.plano?.codigoPLANO;
      if (selectedPlan && !formData.planoIMOVEL) {
        setFormData(prev => ({ ...prev, planoIMOVEL: selectedPlan }));
      }
    } catch {
      // Ignore errors
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.pacoteIMOVEL, planosCheckout]);
  const [imobiliarias, setImobiliarias] = useState([]);
  const [agentes, setAgentes] = useState([]);

  // Autocomplete Google Places
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const autocompleteTimeout = useRef(null);

  // Busca sugestões usando a Google Maps JS API
  const handleAddressAutocomplete = (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, enderecoIMOVEL: value }));
    if (autocompleteTimeout.current) clearTimeout(autocompleteTimeout.current);
    if (!value) {
      setAddressSuggestions([]);
      return;
    }
    autocompleteTimeout.current = setTimeout(() => {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        return;
      }
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        {
          input: value,
          language: 'pt'
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            setAddressSuggestions(predictions || []);
          } else {
            setAddressSuggestions([]);
          }
        }
      );
    }, 400);
  };

  // Busca detalhes do Endereço selecionado usando PlacesService
  const handleSelectAddress = (suggestion) => {
    setAddressSuggestions([]);
    setFormData(prev => ({ ...prev, enderecoIMOVEL: suggestion.description }));
    if (!window.google || !window.google.maps || !window.google.maps.places) return;
    const service = new window.google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails({ placeId: suggestion.place_id, language: 'pt' }, (data, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && data) {
        const { address_components, geometry } = data;
        let numero = '', cidade = '', estado = '', pais = '', cep = '';
        address_components.forEach(comp => {
          if (comp.types.includes('street_number')) numero = comp.long_name;
          if (comp.types.includes('locality')) cidade = comp.long_name;
          if (!cidade && comp.types.includes('administrative_area_level_2')) cidade = comp.long_name;
          if (comp.types.includes('administrative_area_level_1')) estado = comp.short_name || comp.long_name;
          if (comp.types.includes('country')) pais = comp.short_name;
          if (comp.types.includes('postal_code')) cep = comp.long_name;
        });
        // Garante que fotos e outros campos Não sejam perdidos ao preencher Endereço
        setFormData(prev => ({
          ...prev,
          enderecoIMOVEL: suggestion.description,
          numeroIMOVEL: numero,
          cityIMOVEL: cidade,
          stateIMOVEL: estado,
          paisIMOVEL: pais,
          countryIMOVEL: pais,
          zipcodeIMOVEL: cep,
          latitudeIMOVEL: geometry.location.lat(),
          longitudeIMOVEL: geometry.location.lng(),
          fotos: prev.fotos // mantém as fotos já adicionadas
        }));
      }
    });
  };

  // Carrega tipos de Imóvel ao montar
  React.useEffect(() => {
    const fetchTipos = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/tiposimovel`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setTiposImovel(data);
        }
      } catch (err) {
        setTiposImovel([]);
      }
    };
    fetchTipos();
  }, []);

  // Carrega categorias ao montar
  React.useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/categorias`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setCategorias(data);
        }
      } catch (err) {
        setCategorias([]);
      }
    };
    fetchCategorias();
  }, []);

  // Carrega planos ao montar
  React.useEffect(() => {
    const fetchPlanos = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/checkouts`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setPlanosCheckout(data);
          // Buscar contagem real de anúncios
          fetchAnunciosCount();
        }
      } catch (err) {
        setPlanosCheckout([]);
      }
    };
    fetchPlanos();
  }, [fetchAnunciosCount]);

  // Filtra categorias conforme tipo selecionado
  const categoriasFiltradas = formData.tipoIMOVEL
  ? categorias.filter(cat => String(cat.tipoCATEGORIA) === String(formData.tipoIMOVEL))
  : categorias;


  // Carrega tipos de Imóvel ao montar
  React.useEffect(() => {
    const fetchTipos = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/tiposimovel`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setTiposImovel(data);
        }
      } catch (err) {
        setTiposImovel([]);
      }
    };
    fetchTipos();
  }, []);

  // Fetch imobiliarias from API on component mount
  React.useEffect(() => {
    const fetchImobiliarias = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/imobiliarias`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setImobiliarias(data);
        }
      } catch (err) {
        setImobiliarias([]);
      }
    };
    fetchImobiliarias();
  }, []);

  // Fetch agentes from API on component mount
  React.useEffect(() => {
    const fetchAgentes = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/agentes`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setAgentes(data);
        }
      } catch (err) {
        setAgentes([]);
      }
    };
    fetchAgentes();
  }, []);

  // Atualiza o localStorage com os dados do formulário
  const saveFormDataToLocalStorage = () => {
    try {
      localStorage.setItem('newListingFormData', JSON.stringify(formData));
    } catch (err) {
      console.error('Erro ao salvar no localStorage:', err);
    }
  };

  // Preview modal (replicado do NewListing, usando formData da tela)
  const fotos = Array.isArray(formData.fotos) ? formData.fotos : [];
  // eslint-disable-next-line no-unused-vars
  const primary = fotos.find(f => f.padraoFOTO === 1) || fotos[0];


  // REMOVIDO: Carregamento do localStorage em modo de edição
  // Em modo de edição, os dados devem vir apenas da API para garantir consistência
  // O localStorage era usado apenas para rascunhos de novos anúncios

  // Extrai o clienteIMOVEL do auth_token no localStorage
  React.useEffect(() => {
    try {
      const token = localStorage.getItem('auth_token');
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1])); // Decodifica o payload do JWT
        if (payload && payload.codigo) {
          setFormData(prev => ({ ...prev, clienteIMOVEL: payload.codigo }));
        }
      }
    } catch (err) {
      console.error('Erro ao extrair clienteIMOVEL do auth_token:', err);
    }
  }, []);

  // Busca os dados do Imóvel ao montar o componente
  useEffect(() => {
    const fetchImovel = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/imoveis/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          console.log('📥 DEBUG: Dados recebidos da API:', data);
          console.log('🆔 DEBUG: ID do imóvel nos dados recebidos:', data.codigoIMOVEL);
          const newData = {
            ...data.dadosBasicos,
            ...data.enderecos,
            ...data.caracteristicas,
            fotos: (data.fotos || []).map(foto => ({
              ...foto,
              pathFOTO: foto.urlFOTO
            })),
            videoIMOVEL: data.midia?.videoIMOVEL || '',
            "360IMOVEL": data.midia?.["360IMOVEL"] || '',
            comodidadesIMOVEL: data.comodidadesIMOVEL || []
          };
          // Normaliza comodidadesIMOVEL para sempre ser um array de strings
          if (typeof newData.comodidadesIMOVEL === 'string') {
            const s = newData.comodidadesIMOVEL.trim();
            try {
              const parsed = JSON.parse(s);
              if (Array.isArray(parsed)) newData.comodidadesIMOVEL = parsed.map(x => String(x).trim()).filter(Boolean);
              else newData.comodidadesIMOVEL = s ? s.split(',').map(x => x.trim()).filter(Boolean) : [];
            } catch {
              newData.comodidadesIMOVEL = s ? s.split(',').map(x => x.trim()).filter(Boolean) : [];
            }
          } else if (!Array.isArray(newData.comodidadesIMOVEL)) {
            newData.comodidadesIMOVEL = [];
          }
          // Copia do nível raiz quando presente (alguns campos vêm fora de 'caracteristicas')
          const rootCopy = [
            'andaresIMOVEL','casadebanhoIMOVEL','anoconstrucaoIMOVEL','situacaoIMOVEL','posicaosolarIMOVEL',
            'tipometragemIMOVEL','tvIMOVEL','aquecimentoIMOVEL','cozinhaIMOVEL','maquinadelavarIMOVEL',
            'estacionamentoIMOVEL','piscinaIMOVEL','varandaIMOVEL','churrasqueiraIMOVEL','seguranca24hIMOVEL',
            'mobiliadoIMOVEL','politicacancelamentoIMOVEL','financiamentoIMOVEL','limpezaCobrada',
            'valorLimpeza','taxaTurismoCobrada','valorTaxaTurismoAdulto','valorTaxaTurismoCrianca',
            'idadeMaximaCrianca','tituloIMOVEL','slugIMOVEL','tipoIMOVEL','categoriaIMOVEL','planoIMOVEL',
            'pacoteIMOVEL','descricaoIMOVEL','regrasadicionaisIMOVEL','valorIMOVEL','labelvalorIMOVEL',
            'imobiliariaIMOVEL','agenteIMOVEL','clienteIMOVEL','idIMOVEL','codigoIMOVEL','ativoIMOVEL',
            'instantBooking','permanenciaminimaIMOVEL','permanenciamaximaIMOVEL','checkinIMOVEL',
            'checkoutIMOVEL','qtdpessoasIMOVEL','solteirocamasIMOVEL','casalcamasIMOVEL','casadebanhoIMOVEL','quartosIMOVEL',
            'vagasgaragemIMOVEL','metragemIMOVEL','floorIMOVEL','wifiIMOVEL','arcondicionadoIMOVEL',
            'fumarIMOVEL','salaodejogosIMOVEL','portariaIMOVEL','playgroundIMOVEL','proximoaometroIMOVEL',
            'elevadorIMOVEL','poraoIMOVEL','quadraesportivaIMOVEL','festaIMOVEL','academiaIMOVEL',
            'saunaIMOVEL','petsIMOVEL','coberturaIMOVEL','criancasIMOVEL','quadrabasqueteIMOVEL',
            'sotaoIMOVEL','porteiroIMOVEL','jardimdefrenteIMOVEL','vistadolagoIMOVEL','vistadomarIMOVEL',
            'espacoprivadoIMOVEL','adegaIMOVEL','sprinklersIMOVEL','lavanderiaIMOVEL','closetIMOVEL','exibirPreco'
          ];
          rootCopy.forEach(k => {
            // Preserva valores incluindo 0, false e null - apenas ignora undefined
            if (typeof data[k] !== 'undefined') {
              newData[k] = data[k];
            }
          });

          // Normaliza campos booleanos (0/1) para garantir consistência
          const booleanFields = [
            'wifiIMOVEL','tvIMOVEL','aquecimentoIMOVEL','cozinhaIMOVEL','maquinadelavarIMOVEL',
            'estacionamentoIMOVEL','piscinaIMOVEL','varandaIMOVEL','churrasqueiraIMOVEL',
            'seguranca24hIMOVEL','mobiliadoIMOVEL','arcondicionadoIMOVEL',
            'fumarIMOVEL','salaodejogosIMOVEL','portariaIMOVEL','playgroundIMOVEL',
            'proximoaometroIMOVEL','elevadorIMOVEL','poraoIMOVEL','quadraesportivaIMOVEL',
            'festaIMOVEL','academiaIMOVEL','saunaIMOVEL','petsIMOVEL','coberturaIMOVEL',
            'criancasIMOVEL','quadrabasqueteIMOVEL','sotaoIMOVEL','porteiroIMOVEL',
            'jardimdefrenteIMOVEL','vistadolagoIMOVEL','vistadomarIMOVEL','espacoprivadoIMOVEL',
            'adegaIMOVEL','sprinklersIMOVEL','lavanderiaIMOVEL','closetIMOVEL','instantBooking',
            'limpezaCobrada','taxaTurismoCobrada','exibirPreco'
          ];
          booleanFields.forEach(field => {
            if (typeof newData[field] !== 'undefined') {
              // Converte para boolean true/false para uso no formulário
              const val = newData[field];
              if (val === true || val === 'true' || val === 1 || val === '1') {
                newData[field] = true;
              } else if (val === false || val === 'false' || val === 0 || val === '0' || val === '') {
                newData[field] = false;
              } else {
                // Mantém valor original se não for um booleano padrão
                newData[field] = val;
              }
            }
          });

          // Fallback: mapear string antiga 'cancellationPolicy' para o novo campo numérico
          if (!newData.politicacancelamentoIMOVEL) {
            const old = (data.cancellationPolicy || '').toString().toLowerCase();
            if (old === 'flexible') newData.politicacancelamentoIMOVEL = 1;
            else if (old === 'moderate') newData.politicacancelamentoIMOVEL = 2;
            else if (old === 'strict') newData.politicacancelamentoIMOVEL = 3;
          }
          // Normaliza politicacancelamentoIMOVEL para número se vier como string
          if (typeof newData.politicacancelamentoIMOVEL === 'string') {
            const n = Number(newData.politicacancelamentoIMOVEL);
            if (Number.isFinite(n)) newData.politicacancelamentoIMOVEL = n;
          }
          // Para campos duplicados entre dadosBasicos e caracteristicas, prioriza dadosBasicos quando houver valor válido (>0)
          const db = data.dadosBasicos || {};
          const preferDbIfPositive = (key) => {
            const v = Number(db[key]);
            if (Number.isFinite(v) && v > 0) newData[key] = v;
          };
          preferDbIfPositive('andaresIMOVEL');
          preferDbIfPositive('casadebanhoIMOVEL');
          preferDbIfPositive('anoconstrucaoIMOVEL');
          preferDbIfPositive('situacaoIMOVEL');
          preferDbIfPositive('posicaosolarIMOVEL');
          preferDbIfPositive('tipometragemIMOVEL');

          // Normaliza País na Edição
          // Se o backend retorna countryIMOVEL (ex.: "BR") e paisIMOVEL vem vazio/0, usamos countryIMOVEL para preencher o campo exibido
          if ((newData.paisIMOVEL === undefined || newData.paisIMOVEL === null || String(newData.paisIMOVEL) === '' || String(newData.paisIMOVEL) === '0')
              && typeof newData.countryIMOVEL !== 'undefined' && String(newData.countryIMOVEL) !== '') {
            newData.paisIMOVEL = newData.countryIMOVEL;
          }
          // Converte tipometragem numérica do backend para label usado no select
          if (newData.tipometragemIMOVEL === 1 || newData.tipometragemIMOVEL === '1') newData.tipometragemIMOVEL = 'm²';
          else if (newData.tipometragemIMOVEL === 2 || newData.tipometragemIMOVEL === '2') newData.tipometragemIMOVEL = 'ft²';
          // Converte situação e posição solar numéricas para labels do select
          if (newData.situacaoIMOVEL === 1 || newData.situacaoIMOVEL === '1') newData.situacaoIMOVEL = 'novo';
          else if (newData.situacaoIMOVEL === 2 || newData.situacaoIMOVEL === '2') newData.situacaoIMOVEL = 'usado';
          else if (newData.situacaoIMOVEL === 3 || newData.situacaoIMOVEL === '3') newData.situacaoIMOVEL = 'em_construcao';
          if (newData.posicaosolarIMOVEL === 1 || newData.posicaosolarIMOVEL === '1') newData.posicaosolarIMOVEL = 'norte';
          else if (newData.posicaosolarIMOVEL === 2 || newData.posicaosolarIMOVEL === '2') newData.posicaosolarIMOVEL = 'sul';
          else if (newData.posicaosolarIMOVEL === 3 || newData.posicaosolarIMOVEL === '3') newData.posicaosolarIMOVEL = 'leste';
          else if (newData.posicaosolarIMOVEL === 4 || newData.posicaosolarIMOVEL === '4') newData.posicaosolarIMOVEL = 'oeste';

          console.log('🚿 DEBUG: casadebanhoIMOVEL recebido da API:', data.casadebanhoIMOVEL);
          console.log('🚿 DEBUG: banheirosIMOVEL recebido da API:', data.banheirosIMOVEL);
          console.log('🚿 DEBUG: newData.casadebanhoIMOVEL após processamento:', newData.casadebanhoIMOVEL);
          console.log('🧹 DEBUG: limpezaCobrada recebido da API:', data.limpezaCobrada);
          console.log('🧹 DEBUG: valorLimpeza recebido da API:', data.valorLimpeza);
          console.log('🧹 DEBUG: newData.limpezaCobrada após processamento:', newData.limpezaCobrada);
          console.log('🧹 DEBUG: newData.valorLimpeza após processamento:', newData.valorLimpeza);
          console.log('🏖️ DEBUG: taxaTurismoCobrada recebido da API:', data.taxaTurismoCobrada);
          console.log('🏖️ DEBUG: valorTaxaTurismoAdulto recebido da API:', data.valorTaxaTurismoAdulto);
          console.log('🏖️ DEBUG: valorTaxaTurismoCrianca recebido da API:', data.valorTaxaTurismoCrianca);
          console.log('🏖️ DEBUG: idadeMaximaCrianca recebido da API:', data.idadeMaximaCrianca);
          console.log('🏖️ DEBUG: newData.taxaTurismoCobrada após processamento:', newData.taxaTurismoCobrada);
          console.log('🏖️ DEBUG: newData.valorTaxaTurismoAdulto após processamento:', newData.valorTaxaTurismoAdulto);
          console.log('🏖️ DEBUG: newData.valorTaxaTurismoCrianca após processamento:', newData.valorTaxaTurismoCrianca);
          console.log('🏖️ DEBUG: newData.idadeMaximaCrianca após processamento:', newData.idadeMaximaCrianca);

          setFormData(newData);
          // Em Edição, mostramos o progresso completo
          setCompletedSteps([1, 2, 3, 4, 5]);
          // Inicia sempre na Etapa 1 ao abrir a Edição
          setCurrentStep(1);
        } else {
          showToast('Erro ao carregar os dados do Imóvel.', 'error');
        }
      } catch (err) {
        showToast('Erro ao carregar os dados do Imóvel.', 'error');
      } finally {
        setLoading(false);
      }
    };
    fetchImovel();
  }, [id]);


  // Adicionei um useRef para armazenar o estado anterior do formData
  const prevFormDataRef = useRef(formData);

  // Debounce para evitar múltiplos PATCH simultâneos
  const debounceTimeout = useRef(null);

  // Extract complex expression for dependency array
  const comodidadesString = JSON.stringify(formData.comodidadesIMOVEL || []);

  const patchData = useCallback(async (field, value) => {
    try {
      // Normalizações antes de enviar
      let payloadValue = value;
      if (field === 'politicacancelamentoIMOVEL' || field === 'financiamentoIMOVEL') {
        const n = Number(value);
        payloadValue = Number.isFinite(n) ? n : '';
      }
      if (['casadebanhoIMOVEL','quartosIMOVEL','vagasgaragemIMOVEL','qtdpessoasIMOVEL','solteirocamasIMOVEL','casalcamasIMOVEL','metragemIMOVEL'].includes(field)) {
        const n = Number(value);
        payloadValue = Number.isFinite(n) ? n : value;
      }
      if (field === 'comodidadesIMOVEL') {
        if (typeof value === 'string') {
          payloadValue = value ? value.split(',').map(v => String(v).trim()).filter(Boolean) : [];
        } else if (!Array.isArray(value)) {
          payloadValue = [];
        }
      }
      if (field === 'exibirPreco') {
        payloadValue = value ? 1 : 0;
      }

      const token = localStorage.getItem('auth_token');
      const payload = { [field]: payloadValue };
      console.log('🔧 DEBUG: PATCH field:', field, 'value:', payloadValue);
      const response = await fetch(`${import.meta.env.VITE_URL_API}/imoveis/${id}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Erro ao realizar PATCH:', errorText);
      }
    } catch (err) {
      console.error('Erro ao realizar PATCH:', err);
    }
  }, [id]);

  // Atualiza o backend ao detectar mudanças nos campos da etapa 5
  useEffect(() => {
    if (!id) return;

    const fieldsToWatch = [
      // Regras e Preços
      'permanenciaminimaIMOVEL',
      'permanenciamaximaIMOVEL',
      'checkinIMOVEL',
      'checkoutIMOVEL',
      'valorIMOVEL',
      'labelvalorIMOVEL',
      'politicacancelamentoIMOVEL',
      'exibirPreco',
      'instantBooking',
      'financiamentoIMOVEL',
      // Descrição e Regras
      'tituloIMOVEL',
      'slugIMOVEL',
      'descricaoIMOVEL',
      'regrasadicionaisIMOVEL',
      // Endereço
      'enderecoIMOVEL','numeroIMOVEL','zipcodeIMOVEL','cityIMOVEL','stateIMOVEL','latitudeIMOVEL','longitudeIMOVEL',
      // País (string ou inteiro)
      'countryIMOVEL','paisIMOVEL',
      // Características
      'tipometragemIMOVEL','andaresIMOVEL','qtdpessoasIMOVEL','solteirocamasIMOVEL','casalcamasIMOVEL','casadebanhoIMOVEL','quartosIMOVEL','vagasgaragemIMOVEL','metragemIMOVEL','anoconstrucaoIMOVEL','situacaoIMOVEL','posicaosolarIMOVEL','floorIMOVEL',
      // Relacionamentos
      'imobiliariaIMOVEL','agenteIMOVEL','codigoIMOVEL',
      // Flags/Amenities inteiras
      'lavanderiaIMOVEL','wifiIMOVEL','closetIMOVEL','arcondicionadoIMOVEL','fumarIMOVEL','salaodejogosIMOVEL','portariaIMOVEL','playgroundIMOVEL','proximoaometroIMOVEL','elevadorIMOVEL','poraoIMOVEL','quadraesportivaIMOVEL','festaIMOVEL','academiaIMOVEL','saunaIMOVEL','petsIMOVEL','coberturaIMOVEL','criancasIMOVEL','quadrabasqueteIMOVEL','sotaoIMOVEL','porteiroIMOVEL','jardimdefrenteIMOVEL','vistadolagoIMOVEL','vistadomarIMOVEL','espacoprivadoIMOVEL','adegaIMOVEL','sprinklersIMOVEL',
      // Novas comodidades explícitas
      'tvIMOVEL','aquecimentoIMOVEL','cozinhaIMOVEL','maquinadelavarIMOVEL','estacionamentoIMOVEL','piscinaIMOVEL','varandaIMOVEL','churrasqueiraIMOVEL','seguranca24hIMOVEL','mobiliadoIMOVEL',
      // Comodidades livres (array)
      'comodidadesIMOVEL'
    ];

    const changes = fieldsToWatch.reduce((acc, field) => {
      if (prevFormDataRef.current[field] !== formData[field]) {
        acc[field] = formData[field];
      }
      return acc;
    }, {});

    if (Object.keys(changes).length > 0) {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        Object.entries(changes).forEach(([field, value]) => patchData(field, value));
      }, 500); // Aguarda 500ms antes de enviar o PATCH
    }

    prevFormDataRef.current = formData; // Atualiza o estado anterior
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // Regras e Preços
    formData.permanenciaminimaIMOVEL,
    formData.permanenciamaximaIMOVEL,
    formData.checkinIMOVEL,
    formData.checkoutIMOVEL,
    formData.valorIMOVEL,
    formData.labelvalorIMOVEL,
    formData.politicacancelamentoIMOVEL,
    formData.instantBooking,
    formData.financiamentoIMOVEL,
    // Descrição e Regras
    formData.tituloIMOVEL,
    formData.slugIMOVEL,
    formData.descricaoIMOVEL,
    formData.regrasadicionaisIMOVEL,
    // Endereço
    formData.enderecoIMOVEL,
    formData.numeroIMOVEL,
    formData.zipcodeIMOVEL,
    formData.cityIMOVEL,
    formData.stateIMOVEL,
    formData.latitudeIMOVEL,
    formData.longitudeIMOVEL,
    // País
    formData.countryIMOVEL,
    formData.paisIMOVEL,
    // Características
    formData.tipometragemIMOVEL,
    formData.andaresIMOVEL,
    formData.qtdpessoasIMOVEL,
    formData.solteirocamasIMOVEL,
    formData.casalcamasIMOVEL,
    formData.casadebanhoIMOVEL,
    formData.quartosIMOVEL,
    formData.vagasgaragemIMOVEL,
    formData.metragemIMOVEL,
    formData.anoconstrucaoIMOVEL,
    formData.situacaoIMOVEL,
    formData.posicaosolarIMOVEL,
    formData.floorIMOVEL,
    // Relacionamentos
    formData.imobiliariaIMOVEL,
    formData.agenteIMOVEL,
    formData.codigoIMOVEL,
    // Flags/Amenities
    formData.lavanderiaIMOVEL,
    formData.wifiIMOVEL,
    formData.closetIMOVEL,
    formData.arcondicionadoIMOVEL,
    formData.fumarIMOVEL,
    formData.salaodejogosIMOVEL,
    formData.portariaIMOVEL,
    formData.playgroundIMOVEL,
    formData.proximoaometroIMOVEL,
    formData.elevadorIMOVEL,
    formData.poraoIMOVEL,
    formData.quadraesportivaIMOVEL,
    formData.festaIMOVEL,
    formData.academiaIMOVEL,
    formData.saunaIMOVEL,
    formData.petsIMOVEL,
    formData.coberturaIMOVEL,
    formData.criancasIMOVEL,
    formData.quadrabasqueteIMOVEL,
    formData.sotaoIMOVEL,
    formData.porteiroIMOVEL,
    formData.jardimdefrenteIMOVEL,
    formData.vistadolagoIMOVEL,
    formData.vistadomarIMOVEL,
    formData.espacoprivadoIMOVEL,
    formData.adegaIMOVEL,
    formData.sprinklersIMOVEL,
    // Comodidades livres (array)
    comodidadesString,
    id,
    formData,
    patchData,
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ]);

  const steps = [
    { number: 1, text: 'Informações Básicas' },
    { number: 2, text: 'Mídias' },
    { number: 3, text: 'Localização' },
    { number: 4, text: 'Comodidades' },
    { number: 5, text: 'Regras e Preços' },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Limite máximo de fotos permitido
  const MAX_FOTOS = 60;

  const handlePhotoUpload = (e) => {
    let files = Array.from(e.target.files || []);
    if (!files.length) return;

    const currentCount = Array.isArray(formData.fotos) ? formData.fotos.length : 0;
    const remaining = MAX_FOTOS - currentCount;
    if (remaining <= 0) {
      showToast(`Limite de ${MAX_FOTOS} fotos atingido.`, 'error');
      return;
    }
    if (files.length > remaining) {
      files = files.slice(0, remaining);
      showToast(`Você pode adicionar mais ${remaining} foto(s). As demais foram ignoradas.`, 'error');
    }

    files.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => {
          if (!Array.isArray(prev.fotos)) prev.fotos = [];
          if (prev.fotos.length >= MAX_FOTOS) return prev;
          const newFotos = [
            ...prev.fotos,
            {
              codigoFOTO: Date.now() + Math.floor(Math.random() * 10000),
              imovelFOTO: prev.codigoIMOVEL || '',
              pathFOTO: reader.result, // base64 temporário
              urlFOTO: '',
              padraoFOTO: prev.fotos.length === 0 ? 1 : 0
            }
          ];
          return { ...prev, fotos: newFotos };
        });
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemovePhoto = (index) => {
    setFormData(prev => {
      const newFotos = prev.fotos.filter((_, i) => i !== index);
      return {
        ...prev,
        fotos: newFotos.map((f, i) => ({ ...f, padraoFOTO: i === 0 ? 1 : 0 }))
      };
    });
  };

  // Drag and drop ordering
  const handleDragStart = (index) => {
    dragIndexRef.current = index;
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleDrop = (targetIndex) => {
    const from = dragIndexRef.current;
    if (from === null || from === undefined || from === targetIndex) return;
    setFormData(prev => {
      const arr = Array.isArray(prev.fotos) ? [...prev.fotos] : [];
      const [moved] = arr.splice(from, 1);
      arr.splice(targetIndex, 0, moved);
      // Recalcula principal: índice 0 vira padraoFOTO = 1
      const ordered = arr.map((f, i) => ({ ...f, padraoFOTO: i === 0 ? 1 : 0 }));
      return { ...prev, fotos: ordered };
    });
    dragIndexRef.current = null;
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <FormSection>
            <SectionTitle>Informações Básicas</SectionTitle>
            <FormGrid>
              <InputGroup>
                <Label htmlFor="tituloIMOVEL">Título do Anúncio</Label>
                <Input id="tituloIMOVEL" name="tituloIMOVEL" value={formData.tituloIMOVEL} onChange={e => {
                  handleChange(e);
                  setFormData(prev => ({
                    ...prev,
                    slugIMOVEL: e.target.value.toLowerCase().replace(/\s+/g, '')
                  }));
                }} placeholder="Ex: Apartamento moderno no centro" required />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="slugIMOVEL">Slug</Label>
                <Input id="slugIMOVEL" name="slugIMOVEL" value={formData.slugIMOVEL} readOnly style={{ background: '#f7fafc', color: '#a0aec0' }} placeholder="Gerado automaticamente" />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="pacoteIMOVEL">Pacote</Label>
                <ReactSelect
                  inputId="pacoteIMOVEL"
                  name="pacoteIMOVEL"
                  options={planosCheckout
                    .filter(pkg => {
                      if (!pkg || !pkg.ativoCHECKOUT || !pkg.codigoCHECKOUT || !pkg.nomeCHECKOUT) return false;
                      if ((pkg.plano && pkg.plano.tipoPLANO === 1) || (pkg.nomeCHECKOUT && pkg.nomeCHECKOUT.toLowerCase().includes('destaque'))) return false;
                      const pacoteId = String(pkg.codigoCHECKOUT);
                      const usados = anunciosCount[pacoteId] || 0;
                      const qtd = Number(pkg.plano?.quantidadePLANO || pkg.quantidadeCHECKOUT) || 0;
                      return usados < qtd;
                    })
                    .map(pkg => {
                      const pacoteId = String(pkg.codigoCHECKOUT);
                      const usados = anunciosCount[pacoteId] || 0;
                      const qtd = Number(pkg.plano?.quantidadePLANO || pkg.quantidadeCHECKOUT) || 0;
                      return {
                        value: pkg.codigoCHECKOUT,
                        label: `${pkg.plano && pkg.plano.tipoPlano && pkg.plano.tipoPlano.planoTIPOPLANO ? pkg.plano.tipoPlano.planoTIPOPLANO + ' - ' : ''}${pkg.nomeCHECKOUT} (${usados} de ${qtd})`
                      };
                    })}
                  value={(() => {
                    // 1) Prefer selected by pacoteIMOVEL
                    let selected = planosCheckout.find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
                    // 2) Fallback: find any checkout that matches planoIMOVEL (for registros antigos sem pacoteIMOVEL)
                    if (!selected && formData.planoIMOVEL) {
                      selected = planosCheckout.find(pkg => pkg && pkg.plano && String(pkg.plano.codigoPLANO) === String(formData.planoIMOVEL));
                    }
                    if (!selected) return null;
                    const pacoteId = String(selected.codigoCHECKOUT);
                    const usados = anunciosCount[pacoteId] || 0;
                    const qtd = Number(selected.plano?.quantidadePLANO || selected.quantidadeCHECKOUT) || 0;
                    const prefix = (selected.plano && selected.plano.tipoPlano && selected.plano.tipoPlano.planoTIPOPLANO)
                      ? selected.plano.tipoPlano.planoTIPOPLANO + ' - '
                      : '';
                    return {
                      value: selected.codigoCHECKOUT,
                      label: `${prefix}${selected.nomeCHECKOUT} (${usados} de ${qtd})`
                    };
                  })()}

                  onChange={option => {
                    handleChange({ target: { name: 'pacoteIMOVEL', value: option?.value || '' } });
                    if (option && option.value) {
                      const selected = planosCheckout.find(pkg => String(pkg.codigoCHECKOUT) === String(option.value));
                      if (selected && selected.plano && selected.plano.codigoPLANO) {
                        setFormData(prev => ({ ...prev, planoIMOVEL: selected.plano.codigoPLANO }));
                      }
                    } else {
                      setFormData(prev => ({ ...prev, planoIMOVEL: '' }));
                    }
                  }}
                  placeholder="Selecione um pacote"
                  isClearable
                  isDisabled
                  required
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="planoIMOVEL">Plano</Label>
                <ReactSelect
                  inputId="planoIMOVEL"
                  name="planoIMOVEL"
                  options={(() => {
                    // Prefer option vinculada ao pacote selecionado
                    const byPacote = planosCheckout.find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
                    if (byPacote && byPacote.plano && byPacote.plano.codigoPLANO && byPacote.plano.nomePLANO) {
                      return [{
                        value: byPacote.plano.codigoPLANO,
                        label: byPacote.plano.nomePLANO.replace(/<br\s*\/?>(\s*)?/gi, ' ').replace(/&nbsp;/g, ' ').trim()
                      }];
                    }
                    // Fallback: localizar pelo planoIMOVEL salvo
                    const byPlano = planosCheckout.find(pkg => pkg && pkg.plano && String(pkg.plano.codigoPLANO) === String(formData.planoIMOVEL));
                    if (byPlano && byPlano.plano && byPlano.plano.nomePLANO) {
                      return [{
                        value: byPlano.plano.codigoPLANO,
                        label: byPlano.plano.nomePLANO.replace(/<br\s*\/?>(\s*)?/gi, ' ').replace(/&nbsp;/g, ' ').trim()
                      }];
                    }
                    // Fallback final: mostrar item genérico somente para exibição
                    if (formData.planoIMOVEL) {
                      return [{ value: formData.planoIMOVEL, label: `Plano #${formData.planoIMOVEL}` }];
                    }
                    return [];
                  })()}
                  value={(() => {
                    // Prefer value vinculado ao pacote
                    const byPacote = planosCheckout.find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
                    if (byPacote && byPacote.plano && byPacote.plano.codigoPLANO && String(byPacote.plano.codigoPLANO) === String(formData.planoIMOVEL)) {
                      return {
                        value: byPacote.plano.codigoPLANO,
                        label: byPacote.plano.nomePLANO.replace(/<br\s*\/?>(\s*)?/gi, ' ').replace(/&nbsp;/g, ' ').trim()
                      };
                    }
                    // Fallback pelo plano salvo
                    const byPlano = planosCheckout.find(pkg => pkg && pkg.plano && String(pkg.plano.codigoPLANO) === String(formData.planoIMOVEL));
                    if (byPlano && byPlano.plano && byPlano.plano.nomePLANO) {
                      return {
                        value: byPlano.plano.codigoPLANO,
                        label: byPlano.plano.nomePLANO.replace(/<br\s*\/?>(\s*)?/gi, ' ').replace(/&nbsp;/g, ' ').trim()
                      };
                    }
                    return formData.planoIMOVEL ? { value: formData.planoIMOVEL, label: `Plano #${formData.planoIMOVEL}` } : null;
                  })()}
                  onChange={option => handleChange({ target: { name: 'planoIMOVEL', value: option?.value || '' } })}
                  placeholder={(formData.pacoteIMOVEL || formData.planoIMOVEL) ? 'Plano vinculado ao pacote' : 'Selecione um pacote'}
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                  isDisabled={!formData.pacoteIMOVEL && !formData.planoIMOVEL}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="tipoIMOVEL">Tipo de Imóvel</Label>
                <ReactSelect
                  inputId="tipoIMOVEL"
                  name="tipoIMOVEL"
                  options={(() => {
                    const selected = planosCheckout.find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
                    if (selected && selected.plano && selected.plano.tipoPlano && selected.plano.tipoPlano.slugTIPOPLANO) {
                      const slugPlano = selected.plano.tipoPlano.slugTIPOPLANO;
                      if (slugPlano === 'professional' || slugPlano === 'particular') {
                        const tiposPermitidos = ['arrendar', 'comprar'];
                        return tiposPermitidos
                          .map(slug => tiposImovel.find(tipo => tipo.slugTIPOIMOVEL === slug))
                          .filter(Boolean)
                          .map(tipo => ({
                            value: tipo.codigoTIPOIMOVEL,
                            label: tipo.slugTIPOIMOVEL === 'comprar' ? 'Vender' : tipo.nomeTIPOIMOVEL
                          }));
                      }
                      if (slugPlano === 'ferias' || slugPlano === 'vacation') {
                        return tiposImovel
                          .filter(tipo => tipo.slugTIPOIMOVEL === 'ferias')
                          .map(tipo => ({
                            value: tipo.codigoTIPOIMOVEL,
                            label: tipo.slugTIPOIMOVEL === 'comprar' ? 'Vender' : tipo.nomeTIPOIMOVEL
                          }));
                      }
                    }
                    return tiposImovel.map(tipo => ({
                      value: tipo.codigoTIPOIMOVEL,
                      label: tipo.slugTIPOIMOVEL === 'comprar' ? 'Vender' : tipo.nomeTIPOIMOVEL
                    }));
                  })()}
                  value={(() => {
                    const t = tiposImovel.find(tipo => String(tipo.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
                    if (!t) return null;
                    return {
                      value: formData.tipoIMOVEL,
                      label: t.slugTIPOIMOVEL === 'comprar' ? 'Vender' : (t.nomeTIPOIMOVEL || '')
                    };
                  })()}
                  onChange={option => handleChange({ target: { name: 'tipoIMOVEL', value: option?.value || '' } })}
                  placeholder="Selecione o tipo..."
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="categoriaIMOVEL">Categoria</Label>
                <ReactSelect
                  inputId="categoriaIMOVEL"
                  name="categoriaIMOVEL"
                  options={categoriasFiltradas.map(cat => ({
                    value: cat.codigoCATEGORIA,
                    label: cat.nomeCATEGORIA
                  }))}
                  value={categoriasFiltradas.find(cat => cat.codigoCATEGORIA === formData.categoriaIMOVEL)
                    ? {
                        value: formData.categoriaIMOVEL,
                        label: categoriasFiltradas.find(cat => cat.codigoCATEGORIA === formData.categoriaIMOVEL)?.nomeCATEGORIA
                      }
                    : null}
                  onChange={option => handleChange({ target: { name: 'categoriaIMOVEL', value: option?.value || '' } })}
                  placeholder="Selecione a categoria..."
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>

              <InputGroup className="full-width">
                <Label htmlFor="descricaoIMOVEL">Descrição</Label>
                <TextArea id="descricaoIMOVEL" name="descricaoIMOVEL" value={formData.descricaoIMOVEL} onChange={handleChange} placeholder="Descreva seu Imóvel em detalhes..." required />
              </InputGroup>

              <InputGroup className="full-width">
                <Label htmlFor="regrasadicionaisIMOVEL">Regras Adicionais</Label>
                <TextArea id="regrasadicionaisIMOVEL" name="regrasadicionaisIMOVEL" value={formData.regrasadicionaisIMOVEL} onChange={handleChange} placeholder="Ex: Não permitido fumar, animais de estimação, festas, etc." />
              </InputGroup>

              {role !== 'PARTICULAR' && (
                <>
                  <InputGroup>
                    <Label htmlFor="imobiliariaIMOVEL">Imobiliária</Label>
                    <ReactSelect
                      inputId="imobiliariaIMOVEL"
                      name="imobiliariaIMOVEL"
                      options={imobiliarias.map(imobiliaria => ({
                        value: imobiliaria.codigoIMOBILIARIA,
                        label: imobiliaria.nomeIMOBILIARIA
                      }))}
                      value={imobiliarias.find(imobiliaria => String(imobiliaria.codigoIMOBILIARIA) === String(formData.imobiliariaIMOVEL))
                        ? {
                            value: formData.imobiliariaIMOVEL,
                            label: imobiliarias.find(imobiliaria => String(imobiliaria.codigoIMOBILIARIA) === String(formData.imobiliariaIMOVEL))?.nomeIMOBILIARIA
                          }
                        : null}
                      onChange={option => handleChange({ target: { name: 'imobiliariaIMOVEL', value: option?.value || '' } })}
                      placeholder="Selecione a imobiliária..."
                      isClearable
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                          boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                          minHeight: 48,
                          fontSize: 16
                        }),
                        option: (base, state) => ({
                          ...base,
                          background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                          color: state.isSelected ? '#fff' : '#2d3748',
                          fontSize: 16
                        })
                      }}
                    />
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="agenteIMOVEL">Agente</Label>
                    <ReactSelect
                      inputId="agenteIMOVEL"
                      name="agenteIMOVEL"
                      options={agentes.map(agente => ({
                        value: agente.codigoAGENTE,
                        label: agente.nomeAGENTE
                      }))}
                      value={agentes.find(agente => String(agente.codigoAGENTE) === String(formData.agenteIMOVEL))
                        ? {
                            value: formData.agenteIMOVEL,
                            label: agentes.find(agente => String(agente.codigoAGENTE) === String(formData.agenteIMOVEL))?.nomeAGENTE
                          }
                        : null}
                      onChange={option => handleChange({ target: { name: 'agenteIMOVEL', value: option?.value || '' } })}
                      placeholder="Selecione o agente..."
                      isClearable
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                          boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                          minHeight: 48,
                          fontSize: 16
                        }),
                        option: (base, state) => ({
                          ...base,
                          background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                          color: state.isSelected ? '#fff' : '#2d3748',
                          fontSize: 16
                        })
                      }}
                    />
                  </InputGroup>
                </>
              )}

              <InputGroup>
                <Label htmlFor="codigoIMOVEL">ID do Imóvel</Label>
                <Input id="codigoIMOVEL" name="codigoIMOVEL" value={formData.codigoIMOVEL} onChange={handleChange} placeholder="ID único do Imóvel" required />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="clienteIMOVEL">Cliente</Label>
                <Input
                  id="clienteIMOVEL"
                  name="clienteIMOVEL"
                  value={formData.clienteIMOVEL || ''}
                  readOnly
                  style={{ background: '#f7fafc', color: '#a0aec0' }}
                  placeholder="Código do cliente"
                />
              </InputGroup>

            </FormGrid>
          </FormSection>
        );

      case 2:
        return (
          <FormSection>
            <SectionTitle>Mídias do Imóvel</SectionTitle>
            <PhotosGrid>
              {formData.fotos && formData.fotos.length > 0 ? (
                formData.fotos.map((foto, idx) => {
                  const inputRef = React.createRef();
                  return (
                    <PhotoUploadBox
                      draggable
                      onDragStart={() => handleDragStart(idx)}
                      onDragOver={handleDragOver}
                      onDrop={() => handleDrop(idx)}
                      key={foto.codigoFOTO || idx}
                      $preview={foto.pathFOTO}
                      className={idx === 0 ? 'main-photo' : ''}
                      style={idx === 0 ? { border: '3px solid #34574A', position: 'relative' } : {}}
                      onClick={e => {
                        if (e.target.tagName !== 'BUTTON') {
                          if (!foto.pathFOTO && !foto.urlFOTO) {
                            inputRef.current && inputRef.current.click();
                          }
                        }
                      }}
                    >
                      <input
                        ref={inputRef}
                        type="file"
                        accept="image/*"
                        onChange={handlePhotoUpload}
                        disabled={formData.fotos.length >= MAX_FOTOS}
                      />
                      {!foto.pathFOTO && (
                        <>
                          <span className="icon">ðŸ“·</span>
                          <span className="text">{idx === 0 ? 'Foto Principal' : `Foto ${idx + 1}`}</span>
                        </>
                      )}
                      {foto.pathFOTO && (
                        <>
                          {idx === 0 && (
                            <span style={{
                              position: 'absolute',
                              top: 8,
                              left: 8,
                              background: '#34574A',
                              color: 'white',
                              padding: '2px 8px',
                              borderRadius: '6px',
                              fontSize: '0.75rem',
                              zIndex: 2
                            }}>Principal</span>
                          )}
                          <button
                            className="remove"
                            onClick={e => { e.stopPropagation(); handleRemovePhoto(idx); }}
                            type="button"
                          >
                            ×
                          </button>
                        </>
                      )}
                    </PhotoUploadBox>
                  );
                })
              ) : (
                (() => {
                  const inputRef = React.createRef();
                  return (
                    <PhotoUploadBox className="main-photo" onClick={() => inputRef.current && inputRef.current.click()}>
                      <input
                        ref={inputRef}
                        type="file"
                        accept="image/*"
                        onChange={handlePhotoUpload}
                      />
                      <span className="icon">ðŸ“·</span>
                      <span className="text">Foto Principal<br />Arraste ou clique para upload</span>
                    </PhotoUploadBox>
                  );
                })()
              )}
              {formData.fotos && formData.fotos.length < MAX_FOTOS && (() => {
                const inputRef = React.createRef();
                return (
                  <PhotoUploadBox onClick={() => inputRef.current && inputRef.current.click()}>
                    <input
                      ref={inputRef}
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoUpload}
                    />
                    <span className="icon">ï¼‹</span>
                    <span className="text">Adicionar Foto</span>
                  </PhotoUploadBox>
                );
              })()}
            </PhotosGrid>

            <InputGroup className="full-width">
              <Label htmlFor="videoIMOVEL">Vídeo do Imóvel (Embed YouTube, Vimeo, etc)</Label>
              <TextArea id="videoIMOVEL" name="videoIMOVEL" value={formData.videoIMOVEL || ''} onChange={handleChange} placeholder="Cole aqui o código embed ou link do vídeo" />
            </InputGroup>
            <InputGroup className="full-width">
              <Label htmlFor="360IMOVEL">Tour 360º do Imóvel (Embed)</Label>
              <TextArea id="360IMOVEL" name="360IMOVEL" value={formData["360IMOVEL"] || ''} onChange={handleChange} placeholder="Cole aqui o código embed do tour 360º" />
            </InputGroup>
          </FormSection>
        );

      case 3:
        return (
          <FormSection>
            <SectionTitle>Localização</SectionTitle>
            <FormGrid>
              <InputGroup className="full-width">
                <Label htmlFor="enderecoIMOVEL">Endereço</Label>
                {/* Google Places Autocomplete */}
                <input
                  id="enderecoIMOVEL"
                  name="enderecoIMOVEL"
                  value={formData.enderecoIMOVEL || ''}
                  onChange={handleAddressAutocomplete}
                  placeholder="Digite o Endereço e selecione na lista"
                  autoComplete="off"
                  required
                  style={{padding: 12, border: '2px solid #e2e8f0', borderRadius: 8, fontSize: '1rem'}}
                />
                {/* Lista de sugestões */}
                {addressSuggestions.length > 0 && (
                  <div style={{position: 'absolute', background: '#fff', zIndex: 10, border: '1px solid #e2e8f0', width: '100%', borderRadius: 8}}>
                    {addressSuggestions.map((suggestion, idx) => (
                      <div
                        key={idx}
                        style={{padding: 8, cursor: 'pointer'}}
                        onClick={() => handleSelectAddress(suggestion)}
                      >
                        {suggestion.description}
                      </div>
                    ))}
                  </div>
                )}
              </InputGroup>
              <InputGroup>
                <Label htmlFor="numeroIMOVEL">Número</Label>
                <Input
                  id="numeroIMOVEL"
                  name="numeroIMOVEL"
                  value={formData.numeroIMOVEL || ''}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="zipcodeIMOVEL">Código Postal</Label>
                <Input
                  id="zipcodeIMOVEL"
                  name="zipcodeIMOVEL"
                  value={formData.zipcodeIMOVEL || ''}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="cityIMOVEL">Cidade</Label>
                <Input
                  id="cityIMOVEL"
                  name="cityIMOVEL"
                  value={formData.cityIMOVEL || ''}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="stateIMOVEL">Distrito</Label>
                <Input
                  id="stateIMOVEL"
                  name="stateIMOVEL"
                  value={formData.stateIMOVEL || ''}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="paisIMOVEL">País</Label>
                <Input
                  id="paisIMOVEL"
                  name="paisIMOVEL"
                  value={formData.paisIMOVEL || ''}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="longitudeIMOVEL">Longitude</Label>
                <Input
                  id="longitudeIMOVEL"
                  name="longitudeIMOVEL"
                  value={formData.longitudeIMOVEL || ''}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="latitudeIMOVEL">Latitude</Label>
                <Input
                  id="latitudeIMOVEL"
                  name="latitudeIMOVEL"
                  value={formData.latitudeIMOVEL || ''}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
            </FormGrid>
            {/* Mapa */}
            {formData.latitudeIMOVEL && formData.longitudeIMOVEL && (
              <div style={{marginTop: 24}}>
                <iframe
                  title="Mapa"
                  width="100%"
                  height="300"
                  frameBorder="0"
                  style={{border:0, borderRadius: 12}}
                  src={`https://www.google.com/maps?q=${formData.latitudeIMOVEL},${formData.longitudeIMOVEL}&hl=pt-BR&z=16&output=embed`}
                  allowFullScreen
                ></iframe>
              </div>
            )}
          </FormSection>
        );

      case 4: {
        // Lista de comodidades do JSON fornecido pelo usuário
        const jsonAmenitiesRaw = {
          fumarIMOVEL: 'Fumar',
          quadraesportivaIMOVEL: 'Quadra Esportiva',
          arcondicionadoIMOVEL: 'Ar Condicionado',
          coberturaIMOVEL: 'Cobertura',
          petsIMOVEL: 'Pets',
          wifiIMOVEL: 'Wi-Fi',
          vagasgaragemIMOVEL: 'Vagas de Garagem',
          saunaIMOVEL: 'Sauna',
          playgroundIMOVEL: 'Playground',
          lavanderiaIMOVEL: 'Lavanderia',
          elevadorIMOVEL: 'Elevador',
          festaIMOVEL: 'Festas',
          poraoIMOVEL: 'Porão',
          portariaIMOVEL: 'Portaria',
          proximoaometroIMOVEL: 'Proximidade ao Metrô',
          academiaIMOVEL: 'Academia',
          salaodejogosIMOVEL: 'Salão de Jogos',
        };
        // Lista fixa antiga
        const fixedAmenities = [
          { key: 'Wi-Fi', label: 'Wi-Fi' },
          { key: 'TV', label: 'TV' },
          { key: 'Ar Condicionado', label: 'Ar Condicionado' },
          { key: 'Aquecimento', label: 'Aquecimento' },
          { key: 'Cozinha', label: 'Cozinha' },
          { key: 'Máquina de Lavar', label: 'Máquina de Lavar' },
          { key: 'Estacionamento', label: 'Estacionamento' },
          { key: 'Piscina', label: 'Piscina' },
          { key: 'Academia', label: 'Academia' },
          { key: 'Elevador', label: 'Elevador' },
          { key: 'Varanda', label: 'Varanda' },
          { key: 'Churrasqueira', label: 'Churrasqueira' },
          { key: 'Segurança 24h', label: 'Segurança 24h' },
          { key: 'Vista para o Mar', label: 'Vista para o Mar' },
          { key: 'Mobiliado', label: 'Mobiliado' },
        ];
        // Mescla as opções do JSON e as fixas. Normaliza labels -> chaves do backend e deduplica por key
        const normalize = (s) => (s || '').toString()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .toLowerCase().replace(/\s+/g, ' ').trim();
        const labelToKey = {
          'tv': 'tvIMOVEL',
          'aquecimento': 'aquecimentoIMOVEL',
          'cozinha': 'cozinhaIMOVEL',
          'maquina de lavar': 'maquinadelavarIMOVEL',
          'estacionamento': 'estacionamentoIMOVEL',
          'piscina': 'piscinaIMOVEL',
          'varanda': 'varandaIMOVEL',
          'churrasqueira': 'churrasqueiraIMOVEL',
          'seguranca 24h': 'seguranca24hIMOVEL',
          'mobiliado': 'mobiliadoIMOVEL',
          'vista para o mar': 'vistadomarIMOVEL',
        };
        const combinedAmenities = [
          ...Object.entries(jsonAmenitiesRaw).map(([key, label]) => ({ key, label })),
          ...fixedAmenities.filter(fa => !Object.values(jsonAmenitiesRaw).includes(fa.label)),
        ].map(a => ({ key: labelToKey[normalize(a.label)] || a.key, label: a.label }));
        const mergedAmenities = Array.from(new Map(combinedAmenities.map(a => [a.key, a])).values());
        // Lógica para exibição condicional de camas e unidade da área, como no NewListing
        const selectedTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
        const tipoSlug = selectedTipo?.slugTIPOIMOVEL;
        const isFerias = tipoSlug === 'ferias' || tipoSlug === 'vacation';
        const isArrendarMobiliado = tipoSlug === 'arrendar' && (formData['Mobiliado'] === 1);
        const showBeds = Boolean(isFerias || isArrendarMobiliado);
        const areaUnit = formData.tipometragemIMOVEL === 'ft²' ? 'ft' : 'm²';

        // Helper local para checkboxes de comodidades (evita TDZ/escopo)
        const amenityIsChecked = (val) => {
          if (val === 1 || val === '1' || val === true) return true;
          if (typeof val === 'string') {
            const v = val.trim().toLowerCase();
            return v === 'true' || v === 'on' || v === 'yes' || v === 'sim';
          }
          return false;
        };

        return (
          <FormSection>
            <SectionTitle>Comodidades</SectionTitle>
            <FormGrid>
              <InputGroup>
                <Label htmlFor="qtdpessoasIMOVEL">Número de pessoas</Label>
                <NumericInput
                  id="qtdpessoasIMOVEL"
                  name="qtdpessoasIMOVEL"
                  type="number"
                  value={formData.qtdpessoasIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 4"
                />
              </InputGroup>

              {showBeds && (
                <>
                  <InputGroup>
                    <Label htmlFor="solteirocamasIMOVEL">Camas de Solteiro</Label>
                    <NumericInput
                      id="solteirocamasIMOVEL"
                      name="solteirocamasIMOVEL"
                      type="number"
                      value={formData.solteirocamasIMOVEL || ''}
                      onChange={handleChange}
                      placeholder="Ex: 2"
                    />
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="casalcamasIMOVEL">Camas de Casal</Label>
                    <NumericInput
                      id="casalcamasIMOVEL"
                      name="casalcamasIMOVEL"
                      type="number"
                      value={formData.casalcamasIMOVEL || ''}
                      onChange={handleChange}
                      placeholder="Ex: 1"
                    />
                  </InputGroup>
                </>
              )}

              <InputGroup>
                <Label htmlFor="casadebanhoIMOVEL">Casa de Banho</Label>
                <NumericInput
                  id="casadebanhoIMOVEL"
                  name="casadebanhoIMOVEL"
                  type="number"
                  value={formData.casadebanhoIMOVEL !== undefined && formData.casadebanhoIMOVEL !== null ? String(formData.casadebanhoIMOVEL) : ''}
                  onChange={handleChange}
                  placeholder="Ex: 2"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="quartosIMOVEL">Quartos</Label>
                <NumericInput
                  id="quartosIMOVEL"
                  name="quartosIMOVEL"
                  type="number"
                  value={formData.quartosIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 3"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="vagasgaragemIMOVEL">Garagem</Label>
                <NumericInput
                  id="vagasgaragemIMOVEL"
                  name="vagasgaragemIMOVEL"
                  type="number"
                  value={formData.vagasgaragemIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 1"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="tipometragemIMOVEL">Tipo da Metragem</Label>
                <ReactSelect
                  inputId="tipometragemIMOVEL"
                  name="tipometragemIMOVEL"
                  options={[
                    { value: 'm²', label: 'm²' },
                    { value: 'ft²', label: 'ft²' }
                  ]}
                  value={(() => {
                    const opts = [
                      { value: 'm²', label: 'm²' },
                      { value: 'ft²', label: 'ft²' }
                    ];
                    let cur = formData.tipometragemIMOVEL;
                    if (cur === 1 || cur === '1') cur = 'm²';
                    else if (cur === 2 || cur === '2') cur = 'ft²';
                    else if (cur === 0 || cur === '0' || cur === undefined || cur === null) cur = 'm²'; // Default to m²
                    return opts.find(opt => opt.value === cur) || null;
                  })()}
                  onChange={option => handleChange({ target: { name: 'tipometragemIMOVEL', value: option ? option.value : '' } })}
                  placeholder="Selecione"
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="metragemIMOVEL">Área ({areaUnit})</Label>
                <NumericInput
                  id="metragemIMOVEL"
                  name="metragemIMOVEL"
                  type="number"
                  value={formData.metragemIMOVEL || ''}
                  onChange={handleChange}
                  placeholder={areaUnit === 'ft' ? 'Ex: 1292' : 'Ex: 120'}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="andaresIMOVEL">Número de Andares</Label>
                <NumericInput
                  id="andaresIMOVEL"
                  name="andaresIMOVEL"
                  type="number"
                  value={formData.andaresIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 2"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="anoconstrucaoIMOVEL">Ano de Construção</Label>
                <NumericInput
                  id="anoconstrucaoIMOVEL"
                  name="anoconstrucaoIMOVEL"
                  type="number"
                  value={formData.anoconstrucaoIMOVEL !== undefined && formData.anoconstrucaoIMOVEL !== null ? String(formData.anoconstrucaoIMOVEL) : ''}
                  onChange={handleChange}
                  placeholder="Ex: 2020"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="situacaoIMOVEL">Situação do Imóvel</Label>
                <ReactSelect
                  inputId="situacaoIMOVEL"
                  name="situacaoIMOVEL"
                  options={[
                    { value: 'novo', label: 'Novo' },
                    { value: 'usado', label: 'Usado' },
                    { value: 'em_construcao', label: 'Em Construção' }
                  ]}
                  value={(() => {
                    const opts = [
                      { value: 'novo', label: 'Novo' },
                      { value: 'usado', label: 'Usado' },
                      { value: 'em_construcao', label: 'Em Construção' }
                    ];
                    let cur = formData.situacaoIMOVEL;
                    if (cur === 1 || cur === '1') cur = 'novo';
                    else if (cur === 2 || cur === '2') cur = 'usado';
                    else if (cur === 3 || cur === '3') cur = 'em_construcao';
                    else if (cur === 0 || cur === '0' || cur === undefined || cur === null) cur = 'novo'; // Default to novo
                    return opts.find(opt => opt.value === cur) || null;
                  })()}
                  onChange={option => handleChange({ target: { name: 'situacaoIMOVEL', value: option ? option.value : '' } })}
                  placeholder="Selecione"
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="posicaosolarIMOVEL">Posição Solar</Label>
                <ReactSelect
                  inputId="posicaosolarIMOVEL"
                  name="posicaosolarIMOVEL"
                  options={[
                    { value: 'norte', label: 'Norte' },
                    { value: 'sul', label: 'Sul' },
                    { value: 'leste', label: 'Leste' },
                    { value: 'oeste', label: 'Oeste' }
                  ]}
                  value={(() => {
                    const opts = [
                      { value: 'norte', label: 'Norte' },
                      { value: 'sul', label: 'Sul' },
                      { value: 'leste', label: 'Leste' },
                      { value: 'oeste', label: 'Oeste' }
                    ];
                    let cur = formData.posicaosolarIMOVEL;
                    if (cur === 1 || cur === '1') cur = 'norte';
                    else if (cur === 2 || cur === '2') cur = 'sul';
                    else if (cur === 3 || cur === '3') cur = 'leste';
                    else if (cur === 4 || cur === '4') cur = 'oeste';
                    else if (cur === 0 || cur === '0' || cur === undefined || cur === null) cur = 'norte'; // Default to norte
                    return opts.find(opt => opt.value === cur) || null;
                  })()}
                  onChange={option => handleChange({ target: { name: 'posicaosolarIMOVEL', value: option ? option.value : '' } })}
                  placeholder="Selecione"
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>
            </FormGrid>
            <AmenitiesGrid>
              {mergedAmenities.map((amenity) => (
                <Amenity
                  key={amenity.key}
                  $checked={amenityIsChecked(formData[amenity.key])}
                >
                  <input
                    type="checkbox"
                    name={amenity.key}
                    checked={amenityIsChecked(formData[amenity.key])}
                    onChange={(e) => {
                      setFormData(prev => ({
                        ...prev,
                        [amenity.key]: e.target.checked ? 1 : 0
                      }));
                    }}
                  />
                  <span className="text">{amenity.label}</span>
                </Amenity>
              ))}
            </AmenitiesGrid>
            <SectionTitle style={{ marginTop: '32px', marginBottom: '24px', display: 'block' }}>
              Comodidades Extras
            </SectionTitle>
            <ExtrasList>
              {(formData.comodidadesIMOVEL || []).map((amenity, index) => (
                <ExtraItem key={index}>
                  <span className="text">{amenity}</span>
                  <RemoveButton
                    type="button"
                    onClick={() => {
                      setFormData(prev => {
                        const updated = (prev.comodidadesIMOVEL || []).filter((_, i) => i !== index);
                        // PATCH imediato para Não depender só do watcher (UX mais previsível)
                        patchData('comodidadesIMOVEL', updated);
                        return { ...prev, comodidadesIMOVEL: updated };
                      });
                    }}
                    aria-label="Remover comodidade"
                  >
                    <FaTrash size={14} />
                  </RemoveButton>
                </ExtraItem>
              ))}
            </ExtrasList>
            <InputGroup className="full-width" style={{ marginTop: '16px' }}>
              <Label htmlFor="newAmenity">Adicionar Comodidade Extra</Label>
              <AddExtrasRow>
                <Input
                  id="newAmenity"
                  name="newAmenity"
                  value={formData.newAmenity || ''}
                  onChange={(e) => setFormData(prev => ({ ...prev, newAmenity: e.target.value }))}
                  placeholder="Digite uma comodidade extra"
                  style={{ flex: 1 }}
                />
                <AddButton
                  type="button"
                  onClick={() => {
                    if (formData.newAmenity?.trim()) {
                      const item = formData.newAmenity.trim();
                      setFormData(prev => {
                        const list = Array.isArray(prev.comodidadesIMOVEL) ? prev.comodidadesIMOVEL.slice() : [];
                        // permite itens repetidos se o usuário desejar
                        list.push(item);
                        // PATCH imediato para persistir a lista
                        patchData('comodidadesIMOVEL', list);
                        return {
                          ...prev,
                          comodidadesIMOVEL: list,
                          newAmenity: '',
                        };
                      });
                    }
                  }}
                >
                  Adicionar
                </AddButton>
              </AddExtrasRow>
            </InputGroup>
          </FormSection>
        );
      }

      case 5: {
        // Determina o modo pelo tipo de Imóvel
        const selTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
        let slug = selTipo?.slugTIPOIMOVEL || '';
        const nome = (selTipo?.nomeTIPOIMOVEL || '').toLowerCase();
        // Fallback: deduz o modo pelo label do valor quando o slug Não estiver disponível
        if (!slug) {
          const lbl = String(formData.labelvalorIMOVEL || '').toLowerCase();
          if (['Diária','diaria','semana','mês','mes'].includes(lbl)) slug = 'ferias';
          else if (['ano','mês','mes'].includes(lbl)) slug = 'arrendar';
          else if (['venda','comprar','buy','sell'].includes(lbl)) slug = 'comprar';
        }
        const isFeriasStep5 = /^(ferias|vacation|temporada|f[ée]rias|seasonal|holiday)$/i.test(slug) || nome.includes('ferias') || nome.includes('temporada') || nome.includes('férias');
        const isArrendarStep5 = /^(arrendar|rent|aluguel|alugar)$/i.test(slug) || nome.includes('arrendar') || nome.includes('aluguel');
        // Padrão: se Não for Férias nem arrendar, considera comprar
        const isComprarStep5 = /^(comprar|compra|buy|venda|sell)$/i.test(slug) || nome.includes('comprar') || nome.includes('venda') || (!isFeriasStep5 && !isArrendarStep5);
        // Se modo Comprar e o label estiver vazio, define automaticamente como 'venda'
        if (isComprarStep5 && !String(formData.labelvalorIMOVEL || '').trim()) {
          setFormData(prev => ({ ...prev, labelvalorIMOVEL: 'venda' }));
        }

        // OpÃ§Ãµes contextuais para o label do valor
        const priceLabelOptions = isFeriasStep5
          ? [
            { value: 'Diária', label: 'Diária' },
            { value: 'semana', label: 'Semana' },
            { value: 'mês', label: 'Mês' },
          ]
          : isArrendarStep5
            ? [
              { value: 'mês', label: 'Mês' },
              { value: 'ano', label: 'Ano' },
            ]
            : [
              { value: 'venda', label: 'Venda' },
            ];

        return (
          <FormSection>
            <SectionTitle>Regras e Preços</SectionTitle>
            <FormGrid>
              {isFeriasStep5 && (
                <InputGroup>
                  <Label htmlFor="permanenciaminimaIMOVEL">Estadia Mínima (noites)</Label>
                  <NumericInput
                    id="permanenciaminimaIMOVEL"
                    name="permanenciaminimaIMOVEL"
                    type="number"
                    value={formData.permanenciaminimaIMOVEL}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <InputGroup>
                  <Label htmlFor="permanenciamaximaIMOVEL">Estadia Máxima (noites)</Label>
                  <NumericInput
                    id="permanenciamaximaIMOVEL"
                    name="permanenciamaximaIMOVEL"
                    type="number"
                    value={formData.permanenciamaximaIMOVEL}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <InputGroup>
                  <Label htmlFor="checkinIMOVEL">Horário de Check-in</Label>
                  <Input
                    id="checkinIMOVEL"
                    name="checkinIMOVEL"
                    type="time"
                    value={formData.checkinIMOVEL}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <InputGroup>
                  <Label htmlFor="checkoutIMOVEL">Horário de Check-out</Label>
                  <Input
                    id="checkoutIMOVEL"
                    name="checkoutIMOVEL"
                    type="time"
                    value={formData.checkoutIMOVEL}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
              )}

              <InputGroup className="full-width">
                <Label htmlFor="valorIMOVEL">Preço</Label>
                <Input
                  id="valorIMOVEL"
                  name="valorIMOVEL"
                  value={formData.valorIMOVEL}
                  onChange={e => {
                    const raw = e.target.value.replace(/[^0-9.,]/g, '');
                    setFormData(prev => ({ ...prev, valorIMOVEL: raw }));
                  }}
                  placeholder="0,00"
                  required={formData.exibirPreco}
                />
              </InputGroup>

              <InputGroup className="full-width">
                <Label>Exibir preço ao público</Label>
                <RadioGroup>
                  <RadioLabel>
                    <RadioInput
                      type="radio"
                      name="exibirPreco"
                      value="true"
                      checked={formData.exibirPreco === true}
                      onChange={() => setFormData(prev => ({ ...prev, exibirPreco: true }))}
                    />
                    Sim
                  </RadioLabel>
                  <RadioLabel>
                    <RadioInput
                      type="radio"
                      name="exibirPreco"
                      value="false"
                      checked={formData.exibirPreco === false}
                      onChange={() => setFormData(prev => ({ ...prev, exibirPreco: false }))}
                    />
                    Não (Mostrar "Sob consulta")
                  </RadioLabel>
                </RadioGroup>
              </InputGroup>

              {!isFeriasStep5 && (
                <InputGroup className="full-width">
                  <Label htmlFor="labelvalorIMOVEL">Período</Label>
                  <ReactSelect
                    inputId="labelvalorIMOVEL"
                    name="labelvalorIMOVEL"
                    options={priceLabelOptions}
                    value={priceLabelOptions.find(o => o.value === formData.labelvalorIMOVEL) || null}
                    onChange={(option) => handleChange({ target: { name: 'labelvalorIMOVEL', value: option?.value || '' } })}
                    placeholder={isArrendarStep5 ? 'Selecione: Mês/Ano' : 'Venda'}
                    isClearable={!isComprarStep5}
                    isDisabled={isComprarStep5}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                        boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                        minHeight: 48,
                        fontSize: 16
                      }),
                      option: (base, state) => ({
                        ...base,
                        background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                        color: state.isSelected ? '#fff' : '#2d3748',
                        fontSize: 16
                      })
                    }}
                  />
                </InputGroup>
              )}

              {isComprarStep5 && (
                <InputGroup className="full-width">
                  <Label htmlFor="financiamentoIMOVEL">Atende financiamento</Label>
                  <ReactSelect
                    inputId="financiamentoIMOVEL"
                    name="financiamentoIMOVEL"
                    options={[
                      { value: 1, label: 'Sim' },
                      { value: 2, label: 'Não' }
                    ]}
                    value={(() => {
                      const v = Number(formData.financiamentoIMOVEL);
                      const opts = [{ value: 1, label: 'Sim' }, { value: 2, label: 'Não' }];
                      // 0 = default to 'Sim' (1)
                      if (v === 0 || v === '0' || !Number.isFinite(v)) return opts[0];
                      return opts.find(o => o.value === v) || opts[0];
                    })()}
                    onChange={option => handleChange({ target: { name: 'financiamentoIMOVEL', value: option ? Number(option.value) : '' } })}
                    placeholder="Selecione"
                    isClearable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                        boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                        minHeight: 48,
                        fontSize: 16
                      }),
                      option: (base, state) => ({
                        ...base,
                        background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                        color: state.isSelected ? '#fff' : '#2d3748',
                        fontSize: 16
                      })
                    }}
                  />
                </InputGroup>
              )}

              <InputGroup className="full-width">
                <Label htmlFor="politicacancelamentoIMOVEL">Política de Cancelamento</Label>
                <ReactSelect
                  inputId="politicacancelamentoIMOVEL"
                  name="politicacancelamentoIMOVEL"
                  options={[
                    { value: 1, label: 'Flexível (24h)' },
                    { value: 2, label: 'Moderada (5 dias)' },
                    { value: 3, label: 'Rigorosa (7 dias)' }
                  ]}
                  value={(() => {
                    const opts = [
                      { value: 1, label: 'Flexível (24h)' },
                      { value: 2, label: 'Moderada (5 dias)' },
                      { value: 3, label: 'Rigorosa (7 dias)' }
                    ];
                    const v = Number(formData.politicacancelamentoIMOVEL);
                    return opts.find(opt => opt.value === v) || null;
                  })()}
                  onChange={option => handleChange({ target: { name: 'politicacancelamentoIMOVEL', value: option ? Number(option.value) : '' } })}
                  placeholder="Selecione uma Política"
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>

              {isFeriasStep5 && (
                <InputGroup className="full-width">
                  <Label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="checkbox"
                      name="instantBooking"
                      checked={formData.instantBooking}
                      onChange={handleChange}
                    />
                    Aceitar reservas automaticamente
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        backgroundColor: '#34574A',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        cursor: 'help',
                        marginLeft: '4px'
                      }}
                      title="Quando ativada, os hóspedes podem confirmar a reserva imediatamente, sem necessidade de aprovação do anfitrião. As regras de cancelamento continuam a ser as definidas na Política de Cancelamento."
                    >
                      ?
                    </span>
                  </Label>
                  <div style={{ fontSize: '13px', color: '#666', marginTop: '4px', marginLeft: '24px' }}>
                    As reservas serão confirmadas automaticamente, sem necessidade de aprovação manual do anfitrião.
                  </div>
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <>
                  <InputGroup className="full-width">
                    <Label>Limpeza</Label>
                    <div style={{ display: 'flex', gap: '20px', marginTop: '8px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="radio"
                          name="limpezaCobrada"
                          checked={formData.limpezaCobrada === true}
                          onChange={() => handleChange({ target: { name: 'limpezaCobrada', value: true } })}
                        />
                        Sim
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="radio"
                          name="limpezaCobrada"
                          checked={formData.limpezaCobrada === false}
                          onChange={() => handleChange({ target: { name: 'limpezaCobrada', value: false } })}
                        />
                        Não
                      </label>
                    </div>
                  </InputGroup>

                  {formData.limpezaCobrada && (
                    <InputGroup className="full-width">
                      <Label htmlFor="valorLimpeza" className="required">Valor da Limpeza (€)</Label>
                      <MonetaryInput
                        id="valorLimpeza"
                        name="valorLimpeza"
                        type="number"
                        step="0.01"
                        min="0"
                        value={formData.valorLimpeza}
                        onChange={handleChange}
                        placeholder="0.00"
                        required
                      />
                    </InputGroup>
                  )}
                  {!formData.limpezaCobrada && (
                    <div style={{ marginTop: '8px', color: '#666', fontSize: '14px' }}>
                      A limpeza do imóvel é gratuita.
                    </div>
                  )}
                </>
              )}

              {isFeriasStep5 && (
                <>
                  <InputGroup className="full-width">
                    <Label>Taxa de Turismo Cobrada no Local</Label>
                    <div style={{ display: 'flex', gap: '20px', marginTop: '8px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="radio"
                          name="taxaTurismoCobrada"
                          checked={formData.taxaTurismoCobrada === true}
                          onChange={() => handleChange({ target: { name: 'taxaTurismoCobrada', value: true } })}
                        />
                        Sim
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="radio"
                          name="taxaTurismoCobrada"
                          checked={formData.taxaTurismoCobrada === false}
                          onChange={() => handleChange({ target: { name: 'taxaTurismoCobrada', value: false } })}
                        />
                        Não
                      </label>
                    </div>
                  </InputGroup>

                  {formData.taxaTurismoCobrada && (
                    <>
                      <InputGroup>
                        <Label htmlFor="valorTaxaTurismoAdulto" className="required">Valor por Adulto (€)</Label>
                        <MonetaryInput
                          id="valorTaxaTurismoAdulto"
                          name="valorTaxaTurismoAdulto"
                          type="number"
                          step="0.01"
                          min="0"
                          value={formData.valorTaxaTurismoAdulto}
                          onChange={handleChange}
                          placeholder="0.00"
                          required
                        />
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="valorTaxaTurismoCrianca" className="required">Valor por Criança (€)</Label>
                        <MonetaryInput
                          id="valorTaxaTurismoCrianca"
                          name="valorTaxaTurismoCrianca"
                          type="number"
                          step="0.01"
                          min="0"
                          value={formData.valorTaxaTurismoCrianca}
                          onChange={handleChange}
                          placeholder="0.00"
                          required
                        />
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="idadeMaximaCrianca" className="required">Idade Máxima para Criança</Label>
                        <Input
                          id="idadeMaximaCrianca"
                          name="idadeMaximaCrianca"
                          type="number"
                          min="0"
                          max="17"
                          value={formData.idadeMaximaCrianca}
                          onChange={handleChange}
                          placeholder="0-17"
                          required
                        />
                      </InputGroup>
                    </>
                  )}
                  {!formData.taxaTurismoCobrada && (
                    <div style={{ marginTop: '8px', color: '#666', fontSize: '14px' }}>
                      Sem cobrança de taxa de turismo.
                    </div>
                  )}
                </>
              )}
            </FormGrid>
          </FormSection>
        );
      }

      default:
        return null;
    }
  };


  // validação dos campos obrigatórios de cada etapa
  const validateStep = (step) => {
    switch (step) {
      case 1:
        return (
          String(formData.tituloIMOVEL || '').trim() &&
          formData.tipoIMOVEL &&
          formData.categoriaIMOVEL &&
          // aceita plano preenchido diretamente OU via pacote vinculado
          (Boolean(formData.planoIMOVEL) || Boolean(formData.pacoteIMOVEL)) &&
          String(formData.descricaoIMOVEL || '').trim() &&
          (role === 'PARTICULAR' || (formData.imobiliariaIMOVEL && formData.agenteIMOVEL)) &&
          String(formData.codigoIMOVEL || '').trim()
        );
      case 2:
        return Array.isArray(formData.fotos) && formData.fotos.length > 0;
      case 3:
        return (
          formData.enderecoIMOVEL &&
          formData.numeroIMOVEL &&
          formData.zipcodeIMOVEL &&
          formData.cityIMOVEL &&
          formData.stateIMOVEL &&
          formData.paisIMOVEL &&
          formData.longitudeIMOVEL &&
          formData.latitudeIMOVEL
        );
      case 4:
        return Array.isArray(formData.comodidadesIMOVEL) && formData.comodidadesIMOVEL.length >= 0;
      case 5:
        {
          const selTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
          let slug = selTipo?.slugTIPOIMOVEL || '';
          if (!slug) {
            const lbl = String(formData.labelvalorIMOVEL || '').toLowerCase();
            if (['Diária','diaria','semana','mês','mes'].includes(lbl)) slug = 'ferias';
            else if (['ano','mês','mes'].includes(lbl)) slug = 'arrendar';
            else if (['venda','comprar','buy','sell'].includes(lbl)) slug = 'comprar';
          }
          const isFerias = /^(ferias|vacation)$/i.test(slug);
          const isComprar = /^(comprar|compra|buy|venda|sell)$/i.test(slug) || (!/^(ferias|vacation)$/i.test(slug) && !/^(arrendar|rent|aluguel|alugar)$/i.test(slug));
          // Exigir permanências e Horários SOMENTE para Férias/Diária
          const hasMin = isFerias ? Boolean(formData.permanenciaminimaIMOVEL) : true;
          const hasMax = isFerias ? Boolean(formData.permanenciamaximaIMOVEL) : true;
          const hasCheckIn = isFerias ? Boolean(formData.checkinIMOVEL) : true;
          const hasCheckOut = isFerias ? Boolean(formData.checkoutIMOVEL) : true;
          const hasPrice = formData.exibirPreco ? String(formData.valorIMOVEL || '').trim() : true;
          return (
            hasMin && hasMax && hasCheckIn && hasCheckOut &&
            hasPrice &&
            (isFerias || isComprar ? true : String(formData.labelvalorIMOVEL || '').trim()) &&
            Number(formData.politicacancelamentoIMOVEL)
          );
        }
        // return true;
      default:
        return true;
    }
  };

  // Recalcula etapas concluídas com base em dados fornecidos
  // eslint-disable-next-line no-unused-vars
  const recomputeCompleted = (data) => {
    const check = (step) => {
      switch (step) {
        case 1:
          return (
            String(data.tituloIMOVEL || '').trim() &&
            data.tipoIMOVEL &&
            data.categoriaIMOVEL &&
            (Boolean(data.planoIMOVEL) || Boolean(data.pacoteIMOVEL)) &&
            String(data.descricaoIMOVEL || '').trim() &&
            // mesma regra condicional da validação principal
            (role === 'PARTICULAR' || (data.imobiliariaIMOVEL && data.agenteIMOVEL)) &&
            String(data.codigoIMOVEL || '').trim()
          );
        case 2:
          return Array.isArray(data.fotos) && data.fotos.length > 0;
        case 3:
          return (
            data.enderecoIMOVEL &&
            data.numeroIMOVEL &&
            data.zipcodeIMOVEL &&
            data.cityIMOVEL &&
            data.stateIMOVEL &&
            data.paisIMOVEL &&
            data.longitudeIMOVEL &&
            data.latitudeIMOVEL
          );
        case 4:
          return Array.isArray(data.comodidadesIMOVEL);
        case 5:
          { const selTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(data.tipoIMOVEL));
            let slug = selTipo?.slugTIPOIMOVEL || '';
            if (!slug) {
              const lbl = String(data.labelvalorIMOVEL || '').toLowerCase();
              if (['Diária','diaria','semana','mês','mes'].includes(lbl)) slug = 'ferias';
              else if (['ano','mês','mes'].includes(lbl)) slug = 'arrendar';
              else if (['venda','comprar','buy','sell'].includes(lbl)) slug = 'comprar';
            }
            const isFerias = /^(ferias|vacation)$/i.test(slug);
            // Exigir permanências e Horários SOMENTE para Férias/Diária
            const hasMin = isFerias ? Boolean(data.permanenciaminimaIMOVEL) : true;
            const hasMax = isFerias ? Boolean(data.permanenciamaximaIMOVEL) : true;
            const hasCheckIn = isFerias ? Boolean(data.checkinIMOVEL) : true;
            const hasCheckOut = isFerias ? Boolean(data.checkoutIMOVEL) : true;
            return (
              hasMin && hasMax && hasCheckIn && hasCheckOut &&
              String(data.valorIMOVEL || '').trim() &&
              String(data.labelvalorIMOVEL || '').trim() &&
              Number(data.politicacancelamentoIMOVEL)
            );
          }
        default:
          return true;
      }
    };
    const stepsOk = [];
    for (let s = 1; s <= 5; s++) if (check(s)) stepsOk.push(s);
    return stepsOk;
  };

  const handleNext = () => {
    if (!validateStep(currentStep)) {
      showToast('Por favor, preencha todos os campos obrigatórios antes de avançar.', 'error');
      return;
    }
    // Salva os dados no localStorage apenas para persistência local, sem enviar ao backend
    saveFormDataToLocalStorage();
    if (!completedSteps.includes(currentStep)) {
      setCompletedSteps(prev => [...prev, currentStep]);
    }
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      // Ao voltar, remove steps posteriores dos concluídos
      setCompletedSteps(prev => prev.filter(s => s < currentStep));
    }
  };

  return (
    <PageContainer>
      {loading ? (
        <div>Carregando...</div>
      ) : (
        <Container>
          <Sidebar>
            <ProgressSteps
              steps={steps}
              currentStep={currentStep}
              completedSteps={completedSteps}
              onStepClick={goToStep}
            />
          </Sidebar>
          <MainContent>
            <Header>
              <div>
                <Title>Edição de Anúncio</Title>
                <Subtitle>Etapa {currentStep}: {steps.find(s => s.number === currentStep)?.text}</Subtitle>
              </div>
              <EyeButton title="Pré-visualizar Anúncio" onClick={() => setShowPreview(true)}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </EyeButton>
            </Header>

            <form>
              <StepContent>
                {renderStepContent()}
              </StepContent>

              <NavigationButtons>
                <div>
                  {currentStep > 1 && (
                    <Button type="button" className="secondary" onClick={handlePrevious}>
                      Voltar
                    </Button>
                  )}
                </div>
                <div>
                  {currentStep < steps.length && (
                    <Button type="button" className="primary" onClick={handleNext}>
                      Próximo
                    </Button>
                  )}
                  {currentStep === 5 && (
                    <Button type="button" className="primary" onClick={handleSaveAll} style={{ marginLeft: 12 }}>
                      Salvar alterações
                    </Button>
                  )}
                </div>
              </NavigationButtons>
            </form>
          </MainContent>
        </Container>
      )}
      {showPreview && (
        <PreviewModalOverlay onClick={() => setShowPreview(false)}>
          <PreviewModalBox onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h3>Pré-visualização do Anúncio</h3>
              <CloseModal type="button" onClick={() => setShowPreview(false)}>Fechar</CloseModal>
            </ModalHeader>
            <ModalBody>
              {(() => {
                const fotos = Array.isArray(formData.fotos) ? formData.fotos : [];
                if (fotos.length === 0) return null;
                const primary = fotos.find(f => f.padraoFOTO === 1) || fotos[0];
                const rest = fotos.filter(f => f !== primary);
                const thumbs = rest.slice(0, 4);
                return (
                  <HeroGrid>
                    <HeroMain
                      $image={primary.pathFOTO || primary.urlFOTO}
                      onClick={() => { setLightboxIndex(0); setShowLightbox(true); }}
                      role="button"
                    />
                    <RightMosaic>
                      {thumbs.map((f, i) => (
                        <HeroThumb
                          key={f.codigoFOTO || i}
                          $image={f.pathFOTO || f.urlFOTO}
                          onClick={() => { setLightboxIndex(i + 1); setShowLightbox(true); }}
                          role="button"
                        >
                          {i === 1 && (
                            <ViewAllButton type="button" onClick={(e) => { e.stopPropagation(); setLightboxIndex(0); setShowLightbox(true); }}>Ver todas as fotos</ViewAllButton>
                          )}
                        </HeroThumb>
                      ))}
                      {thumbs.length < 4 && Array.from({ length: 4 - thumbs.length }).map((_, idx) => (
                        <HeroThumb key={`ph-${idx}`} />
                      ))}
                    </RightMosaic>
                  </HeroGrid>
                );
              })()}
              <ContentContainer>
                <ActionBar>
                  <LeftGroup>
                    <TopRow>
                      <BackLink onClick={() => setShowPreview(false)}>
                        <FaArrowLeft /> VOLTAR
                      </BackLink>
                      {String(formData.destaqueIMOVEL) === 'true' || formData.destaqueIMOVEL === true ? (
                        <Badge>DESTAQUE</Badge>
                      ) : null}
                    </TopRow>
                    <TitleStatus>
                      {formData.disponivelIMOVEL === '0' || formData.disponivelIMOVEL === 0 ? 'Imóvel indisponível no momento' : (formData.tituloIMOVEL || 'Título do Anúncio')}
                    </TitleStatus>
                    <LocationText>
                      <FaMapMarkerAlt />
                      <span>{formData.enderecoIMOVEL || 'Endereço Não informado'}</span>
                      <span style={{ margin: '0 6px' }}>•</span>
                      <span>{formData.cityIMOVEL || formData.cidadeIMOVEL || formData.city || 'Cidade não informada'}</span>
                    </LocationText>
                  </LeftGroup>
                  <RightGroup>
                    <GhostButton><FaHeart style={{ color: '#BA824F' }} /> Favorito</GhostButton>
                    <GhostButton><FaShare style={{ color: '#6b7280' }} /> Compartilhar</GhostButton>
                  </RightGroup>
                </ActionBar>
                <ModalGrid>
                  <SideInfo>
                    {(() => {
                      const items = [
                        { icon: <FaUser />, label: 'NÚMERO DE PESSOAS', value: formData.qtdpessoasIMOVEL },
                        { icon: <FaBed />, label: 'CAMAS DE SOLTEIRO', value: formData.solteirocamasIMOVEL },
                        { icon: <FaBed />, label: 'CAMAS DE CASAL', value: formData.casalcamasIMOVEL },
                        { icon: <FaBath />, label: 'CASA DE BANHO', value: formData.casadebanhoIMOVEL },
                        { icon: <FaBed />, label: 'QUARTOS', value: formData.quartosIMOVEL },
                        { icon: <FaParking />, label: 'GARAGEM', value: formData.vagasgaragemIMOVEL },
                        { icon: <FaRuler />, label: 'TIPO DA METRAGEM', value: formData.tipometragemIMOVEL || formData.tipoMetragem },
                        { icon: <FaRuler />, label: 'ÁREA (m²)', value: formData.metragemIMOVEL },
                        { icon: <FaHome />, label: 'NÚMERO DE ANDARES', value: formData.andaresIMOVEL || formData.numerodeandaresIMOVEL },
                        { icon: <FaHome />, label: 'ANO DE CONSTRUÇÃO', value: formData.anoconstrucaoIMOVEL },
                        { icon: <FaHome />, label: 'SITUAÇÃO DO IMÓVEL', value: formData.situacaoIMOVEL },
                        { icon: <FaHome />, label: 'POSIÇÃO SOLAR', value: formData.posicaosolarIMOVEL },
                      ].filter(it => it.value !== undefined && it.value !== null && String(it.value).trim() !== '' && String(it.value) !== '0');
                      if (items.length === 0) return null;
                      return (
                        <SectionCard>
                          <PillTitle>Características</PillTitle>
                          <FactsGrid>
                            {items.map((it, idx) => (
                              <FactItem key={idx}>
                                <span style={{ color: '#64748b' }}>{it.icon}</span>
                                <div>
                                  <div className="label">{it.label}</div>
                                  <div className="value">{it.value}</div>
                                </div>
                              </FactItem>
                            ))}
                          </FactsGrid>
                        </SectionCard>
                      );
                    })()}

                    {formData.descricaoIMOVEL && (() => {
                      const full = String(formData.descricaoIMOVEL || '');
                      const limit = 320;
                      const collapsed = full.length > limit ? (full.slice(0, limit).trimEnd() + 'â€¦') : full;
                      const shouldCollapse = full.length > limit;
                      return (
                        <SectionCard>
                          <PillTitle>Descrição</PillTitle>
                          <div style={{ fontSize: 15, color: '#4a5568', lineHeight: 1.7, whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
                            {descriptionExpanded ? full : collapsed}
                          </div>
                          {shouldCollapse && !descriptionExpanded && (
                            <div style={{ marginTop: 10 }}>
                              <button type="button" onClick={() => setDescriptionExpanded(true)} style={{ padding: '8px 12px', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 10, fontWeight: 700, color: '#111827' }}>
                                Mostrar tudo
                              </button>
                            </div>
                          )}
                        </SectionCard>
                      );
                    })()}

                    {(() => {
                      const amenitiesMap = {
                        fumarIMOVEL: 'Fumar', quadraesportivaIMOVEL: 'Quadra Esportiva', arcondicionadoIMOVEL: 'Ar Condicionado', coberturaIMOVEL: 'Cobertura', petsIMOVEL: 'Pets', wifiIMOVEL: 'Wi-Fi', vagasgaragemIMOVEL: 'Vagas de Garagem', casadebanhoIMOVEL: 'Casa de Banho', saunaIMOVEL: 'Sauna', playgroundIMOVEL: 'Playground', lavanderiaIMOVEL: 'Lavanderia', elevadorIMOVEL: 'Elevador', festaIMOVEL: 'Festas', poraoIMOVEL: 'Porão', portariaIMOVEL: 'Portaria', proximoaometroIMOVEL: 'Proximidade ao Metrô', academiaIMOVEL: 'Academia', salaodejogosIMOVEL: 'Salão de Jogos', tvIMOVEL: 'TV', aquecimentoIMOVEL: 'Aquecimento', cozinhaIMOVEL: 'Cozinha', maquinadelavarIMOVEL: 'Máquina de Lavar', estacionamentoIMOVEL: 'Estacionamento incluído', piscinaIMOVEL: 'Piscina', varandaIMOVEL: 'Varanda', churrasqueiraIMOVEL: 'Churrasqueira', seguranca24hIMOVEL: 'Segurança 24h', vistamarIMOVEL: 'Vista para o Mar', mobiliadoIMOVEL: 'Mobiliado', acesso_praiaIMOVEL: 'Acesso à praia', refrigeradorIMOVEL: 'Refrigerador', detectorfumacaIMOVEL: 'Detector de fumaça', alarmemonoxidoIMOVEL: 'Alarme de monóxido de carbono',
                      };
                      const isChecked = (val) => {
                        if (val === 1 || val === '1' || val === true) return true;
                        if (typeof val === 'string') {
                          const v = val.trim().toLowerCase();
                          if (v === 'true' || v === 'on' || v === 'yes' || v === 'sim') return true;
                        }
                        return false;
                      };
                      const labelFromKey = (key) => {
                        if (amenitiesMap[key]) return amenitiesMap[key];
                        const base = key.replace(/IMOVEL$/i, '').replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').trim();
                        if (!base) return '';
                        return base.charAt(0).toUpperCase() + base.slice(1);
                      };
                      const selectedLabels = new Set();
                      Object.entries(formData || {}).forEach(([key, val]) => {
                        if (!isChecked(val)) return;
                        if (typeof key !== 'string') return;
                        if (amenitiesMap[key]) selectedLabels.add(amenitiesMap[key]);
                        else if (/IMOVEL$/i.test(key)) {
                          const label = labelFromKey(key);
                          if (label) selectedLabels.add(label);
                        } else {
                          selectedLabels.add(key);
                        }
                      });
                      const arr = Array.isArray(formData.comodidadesIMOVEL) ? formData.comodidadesIMOVEL : [];
                      arr.forEach(v => { if (!v) return; const s = String(v).trim(); if (amenitiesMap[s]) selectedLabels.add(amenitiesMap[s]); else if (amenitiesMap[s + 'IMOVEL']) selectedLabels.add(amenitiesMap[s + 'IMOVEL']); else selectedLabels.add(s); });
                      let baseList = Array.from(selectedLabels);
                      baseList.sort((a, b) => a.localeCompare(b, 'pt-BR'));
                      const extras = Array.isArray(formData.comodidadesExtras) ? formData.comodidadesExtras.filter(Boolean) : [];
                      const extrasSet = new Set(extras);
                      const extrasSorted = [...extras].sort((a, b) => a.localeCompare(b, 'pt-BR'));
                      if (baseList.length === 0 && extrasSorted.length === 0) return null;
                      const allIcons = {
                        'Acesso à praia': <FaWater className="icon" />, 'Wi-Fi': <FaWifi className="icon" />, 'TV': <FaTv className="icon" />, 'Máquina de Lavar': <FaSnowflake className="icon" />, 'Máquina de lavar': <FaSnowflake className="icon" />, 'Cozinha': <FaUtensils className="icon" />, 'Estacionamento incluído': <FaCar className="icon" />, 'Estacionamento': <FaCar className="icon" />, 'Elevador': <FaArrowsAltV className="icon" />, 'Refrigerador': <FaSnowflake className="icon" />, 'Detector de fumaça': <FaSmokingBan className="icon" />, 'Alarme de monóxido de carbono': <FaBellSlash className="icon" />, 'Piscina': <FaWater className="icon" />, 'Varanda': <FaHome className="icon" />, 'Churrasqueira': <FaUtensils className="icon" />, 'Ar Condicionado': <FaSnowflake className="icon" />, 'Academia': <FaHome className="icon" />, 'Casa de Banho': <FaBath className="icon" />, 'Cobertura': <FaHome className="icon" />, 'Festas': <FaHome className="icon" />, 'Fumar': <FaSmokingBan className="icon" />, 'Pets': <FaHome className="icon" />, 'Playground': <FaHome className="icon" />, 'Portaria': <FaHome className="icon" />, 'Quadra Esportiva': <FaHome className="icon" />, 'Sauna': <FaHome className="icon" />, 'Vagas de Garagem': <FaParking className="icon" />, 'Vista para o Mar': <FaWater className="icon" />, 'Mobiliado': <FaHome className="icon" />, 'Lavanderia': <FaHome className="icon" />, 'Porão': <FaHome className="icon" />, 'Proximidade ao Metrô': <FaHome className="icon" />, 'Salão de Jogos': <FaHome className="icon" />, 'Segurança 24h': <FaHome className="icon" />
                      };
                      const initialCount = 10;
                      const baseToShow = amenitiesExpanded ? baseList : baseList.slice(0, Math.min(initialCount, baseList.length));
                      const baseTotal = baseList.length;
                      const extrasToShow = extrasExpanded ? extrasSorted : extrasSorted.slice(0, Math.min(initialCount, extrasSorted.length));
                      const extrasTotal = extrasSorted.length;
                      return (
                        <SectionCard>
                          <PillTitle>Comodidades</PillTitle>
                          <AmenitiesList>
                            {baseToShow.map((label, idx) => (
                              <AmenityRow key={`row-${idx}`}>
                                {extrasSet.has(label) ? <span style={{ width: 24, height: 24 }} /> : (allIcons[label] || <FaHome className="icon" />)}
                                <div>{label}</div>
                              </AmenityRow>
                            ))}
                          </AmenitiesList>
                          {!amenitiesExpanded && baseTotal > baseToShow.length && (
                            <div style={{ marginTop: 14 }}>
                              <button type="button" onClick={() => setAmenitiesExpanded(true)} style={{ padding: '10px 14px', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 10, fontWeight: 700, color: '#111827' }}>
                                {`Mostrar todas as ${baseTotal} comodidades`}
                              </button>
                            </div>
                          )}
                          {extrasSorted.length > 0 && (
                            <div style={{ marginTop: 18 }}>
                              <div style={{ fontWeight: 700, fontSize: 13, color: '#374151', margin: '0 0 8px' }}>Comodidades Extras</div>
                              <AmenitiesList>
                                {extrasToShow.map((label, idx) => (
                                  <AmenityRow key={`extra-${idx}`}>
                                    <span style={{ width: 24, height: 24 }} />
                                    <div>{label}</div>
                                  </AmenityRow>
                                ))}
                              </AmenitiesList>
                              {!extrasExpanded && extrasTotal > extrasToShow.length && (
                                <div style={{ marginTop: 10 }}>
                                  <button type="button" onClick={() => setExtrasExpanded(true)} style={{ padding: '10px 14px', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 10, fontWeight: 700, color: '#111827' }}>
                                    {`Mostrar todas as ${extrasTotal} comodidades extras`}
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </SectionCard>
                      );
                    })()}

                    {formData.videoIMOVEL && (
                      <SectionCard>
                        <PillTitle>Vídeo Informativo</PillTitle>
                        <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
                          <iframe
                            width="100%"
                            height="315"
                            src={(() => {
                              let input = formData.videoIMOVEL || '';
                              if (/<iframe/i.test(input)) {
                                const m = input.match(/src\s*=\s*"([^"]+)"|src\s*=\s*'([^']+)'/i);
                                input = m ? (m[1] || m[2] || '') : '';
                              }
                              if (/youtube\.com|youtu\.be/.test(input)) {
                                input = input.replace('watch?v=', 'embed/');
                              }
                              if (!/^https?:\/\//i.test(input)) return '';
                              return input;
                            })()}
                            title="Vídeo do Imóvel"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          />
                        </div>
                      </SectionCard>
                    )}

                    {formData["360IMOVEL"] && (
                      <SectionCard>
                        <PillTitle>Tour Virtual 3D</PillTitle>
                        <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
                          <iframe
                            src={(() => {
                              let input = String(formData["360IMOVEL"]) || '';
                              if (/<iframe/i.test(input)) {
                                const m = input.match(/src\s*=\s*"([^"]+)"|src\s*=\s*'([^']+)'/i);
                                input = m ? (m[1] || m[2] || '') : '';
                              }
                              if (!/^https?:\/\//i.test(input)) return '';
                              return input;
                            })()}
                            width="100%"
                            height="360"
                            allowFullScreen
                            style={{ border: 0 }}
                            title="Tour 3D"
                          />
                        </div>
                      </SectionCard>
                    )}

                    {((formData.enderecoIMOVEL && String(formData.enderecoIMOVEL).trim() !== '') || (formData.latitudeIMOVEL && formData.longitudeIMOVEL)) && (
                      <SectionCard>
                        <PillTitle>Localização</PillTitle>
                        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                          <button disabled style={{ padding: '6px 10px', border: '1px solid #e5e7eb', borderRadius: 999, background: '#111', color: '#fff', fontWeight: 700, fontSize: 12 }}>Mapa</button>
                          <button disabled style={{ padding: '6px 10px', border: '1px solid #e5e7eb', borderRadius: 999, background: '#fff', color: '#4b5563', fontWeight: 700, fontSize: 12 }}>Satélite</button>
                        </div>
                        <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e7eb', height: 300 }}>
                          <iframe
                            title="Mapa do Imóvel"
                            src={(formData.latitudeIMOVEL && formData.longitudeIMOVEL)
                              ? `https://maps.google.com/maps?q=${formData.latitudeIMOVEL},${formData.longitudeIMOVEL}&z=15&output=embed`
                              : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.4847274039365!2d-45.5944444!3d-22.7444444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDQ0JzQwLjAiUyA0NcKwMzUnNDAuMCJX!5e0!3m2!1spt-BR!2sbr!4v1625097752726!5m2!1spt-BR!2sbr'}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                          />
                        </div>
                      </SectionCard>
                    )}
                  </SideInfo>
                  {(() => {
                    const selTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
                    let slug = selTipo?.slugTIPOIMOVEL || '';
                    if (!slug) {
                      const lbl = String(formData.labelvalorIMOVEL || '').toLowerCase();
                      if (['venda','comprar','buy','sell'].includes(lbl)) slug = 'comprar';
                    }
                    const isComprar = /^(comprar|compra|buy|venda|sell)$/i.test(slug) || (!/^(ferias|vacation)$/i.test(slug) && !/^(arrendar|rent|aluguel|alugar)$/i.test(slug));
                    return isComprar ? (
                      <BookingBox>
                        <div style={{ background: '#111', color: '#fff', borderRadius: 8, padding: '10px 12px', display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                          <span style={{ fontSize: 22, fontWeight: 800 }}>
                            {formData.valorIMOVEL ? `€ ${String(formData.valorIMOVEL).replace('.', ',')}` : '—'}
                          </span>
                          <span style={{ fontSize: 12, opacity: .9 }}>Preço de venda</span>
                        </div>
                        <button disabled style={{ width: '100%', marginTop: 12, background: '#BA824F', color: '#fff', border: 'none', padding: '12px 16px', borderRadius: 8, fontWeight: 700 }}>
                          Contactar Vendedor
                        </button>
                        <SideAction disabled style={{ marginTop: 10 }}>
                          <FaHeart style={{ color: '#BA824F' }} /> Favorito
                        </SideAction>
                        <SideButton disabled style={{ marginTop: 10 }}>
                          Contactar o anfitrião
                        </SideButton>
                        <SideButton disabled style={{ marginTop: 8 }}>
                          <FaWhatsapp style={{ color: '#22c55e' }} /> WhatsApp do anfitrião
                        </SideButton>
                        <SideButton disabled style={{ marginTop: 8 }}>
                          <FaShare /> Compartilhar
                        </SideButton>
                      </BookingBox>
                    ) : (
                      <BookingBox>
                        <div style={{ background: '#111', color: '#fff', borderRadius: 8, padding: '10px 12px', display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                          <span style={{ fontSize: 22, fontWeight: 800 }}>
                            {formData.valorIMOVEL ? `€ ${String(formData.valorIMOVEL).replace('.', ',')}` : '—'}
                          </span>
                          <span style={{ fontSize: 12, opacity: .9 }}>por {formData.labelvalorIMOVEL || 'noite'}</span>
                        </div>
                        <div style={{ background: '#fff', border: '1px solid #f1f5f9', borderRadius: 12, padding: 12, marginTop: 12 }}>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                            <input disabled placeholder="dd/mm/aaaa" style={{ padding: 10, border: '1px solid #e5e7eb', borderRadius: 10 }} />
                            <input disabled placeholder="dd/mm/aaaa" style={{ padding: 10, border: '1px solid #e5e7eb', borderRadius: 10 }} />
                          </div>
                          <div style={{ marginTop: 8 }}>
                            <input disabled placeholder="N.º de hóspedes" style={{ width: '100%', padding: 10, border: '1px solid #e5e7eb', borderRadius: 10 }} />
                          </div>
                          <div style={{ marginTop: 8 }}>
                            <textarea disabled placeholder="Apresente-se ao anfitrião" rows={4} style={{ width: '100%', padding: 10, border: '1px solid #e5e7eb', borderRadius: 10 }} />
                          </div>
                          <div style={{ color: '#6b7280', fontSize: 13, lineHeight: 1.6, marginTop: 6 }}>
                            Dê uma breve apresentação, Horários aproximados de Check-in e qualquer informação que ajude o anfitrião a recebê-lo melhor.
                          </div>
                        </div>
                        <button disabled style={{ width: '100%', marginTop: 12, background: '#BA824F', color: '#fff', border: 'none', padding: '12px 16px', borderRadius: 8, fontWeight: 700 }}>
                          Solicitar Reserva
                        </button>
                        <SideAction disabled style={{ marginTop: 10 }}>
                          <FaHeart style={{ color: '#BA824F' }} /> Favorito
                        </SideAction>
                        <SideButton disabled style={{ marginTop: 10 }}>
                          Contactar o anfitrião
                        </SideButton>
                        <SideButton disabled style={{ marginTop: 8 }}>
                          <FaWhatsapp style={{ color: '#22c55e' }} /> WhatsApp do anfitrião
                        </SideButton>
                        <SideButton disabled style={{ marginTop: 8 }}>
                          <FaShare /> Compartilhar
                        </SideButton>
                      </BookingBox>
                    );
                  })()}

                    {(() => {
                      const hostName = (currentUser && (
                        currentUser.nome ||
                        currentUser.nomeUSUARIO ||
                        currentUser.name ||
                        currentUser.fullName ||
                        currentUser.username ||
                        currentUser.email
                      )) || 'Anfitrião';
                      const agency = (currentUser && (
                        currentUser?.imobiliaria?.nomeIMOBILIARIA ||
                        currentUser?.nomeIMOBILIARIA ||
                        currentUser?.imobiliaria ||
                        currentUser?.agencia ||
                        currentUser?.agency
                      )) || 'indisponível';
                      const workplace = (currentUser && (
                        currentUser.localTrabalho ||
                        currentUser.workplace ||
                        currentUser.empresa ||
                        currentUser.company
                      )) || '—';
                      return (
                        <HostCard>
                          <div className="avatar">
                            <img alt="Host" src={`https://ui-avatars.com/api/?name=${encodeURIComponent(hostName)}&background=BA824F&color=fff&format=svg`} width="88" height="88" />
                          </div>
                          <div className="name">{hostName}</div>
                          <div className="role">Super Host</div>
                          <div className="line">Imobiliária: {agency}</div>
                          <div className="line">Local de trabalho: {workplace}</div>
                          <div className="rating">★★★★★ <span style={{ color: '#111827' }}>5.0</span> <span style={{ color: '#6b7280' }}>(0 reviews)</span></div>
                        </HostCard>
                      );
                    })()}
                </ModalGrid>
              </ContentContainer>
            </ModalBody>
          </PreviewModalBox>
        </PreviewModalOverlay>
      )}
      {showLightbox && (() => {
        const fotos = Array.isArray(formData.fotos) ? formData.fotos : [];
        if (fotos.length === 0) return null;
        const primary = fotos.find(f => f.padraoFOTO === 1) || fotos[0];
        const rest = fotos.filter(f => f !== primary);
        const ordered = primary ? [primary, ...rest] : rest;
        const current = ordered[lightboxIndex] || ordered[0];
        const goPrev = () => setLightboxIndex((idx) => (idx - 1 + ordered.length) % ordered.length);
        const goNext = () => setLightboxIndex((idx) => (idx + 1) % ordered.length);
        return (
          <LightboxOverlay onClick={() => setShowLightbox(false)}>
            <LightboxImage $image={current.pathFOTO || current.urlFOTO} onClick={(e) => e.stopPropagation()} />
            <LightboxClose onClick={(e) => { e.stopPropagation(); setShowLightbox(false); }}><FaTimes size={24} /></LightboxClose>
            {ordered.length > 1 && (
              <>
                <LightboxNav $left onClick={(e) => { e.stopPropagation(); goPrev(); }}><FaChevronLeft size={24} /></LightboxNav>
                <LightboxNav onClick={(e) => { e.stopPropagation(); goNext(); }}><FaChevronRight size={24} /></LightboxNav>
              </>
            )}
          </LightboxOverlay>
        );
      })()}
      {toast.open && (
        <Toast type={toast.type}>
          {toast.type === 'success' ? '✅' : '❌'}
          <span>{toast.message}</span>
        </Toast>
      )}
    </PageContainer>
  );

};

export { Label, Input, TextArea };
export default EditProperty;
